export default {

    
    seleccionaNegocio: "Seleccione a empresa ...",
    filtraPorEtiqueta: "Filtrar por tag",
    noEncontramosResultadosPara: "Não encontramos resultados para",
    mostrando: "Mostrar",
    resultado: "Resultado",
    resultados: "resultados",
    totalAlmacen: "Armazém Total",
    totalAlmacenDto: "Desconto Total Armazém",
    existenciasTeoricas: "Existências Teóricas",
    diferencia: "Diferença",
    noContabilizado: "Não contabilizado",
    seleccioneUnaFechaDeInicioYUnaFechaDeFin: "Seleccione uma data de início e uma data final",
    inicio: "Começar",
    informes: "Relatórios",
    productos: "produtos",
    ventasPorNegocio: "Vendas por negócio",
    casas: "Casas",
    facturasSimplificadas: "Faturas simplificadas",
    comprasPorNegocio: "Compras comerciais",
    comprasPorCasas: "Compras por casa",
    gastosPorProveedor: "Despesas por fornecedor",
    gastosPorSubproductos: "Gastos matérias primas",
    nuevaCasa: "Casa nova",
    casa: "casa",
    negocio: "Negocio",
    desde: "Desde",
    hasta: "até",
    consultar: "Consultar",
    infoCasas: "Este consumo foi adicionado, nenhum intervalo de dados selecionado",
    exportarInforme: "Relatório de exportação",
    exportarPdf: "Exportar como PDF",
    exportarExcel: "Exportar como Excel",
    exportarExcelSinSubproductos: "Exportar como Excel con materias primas",
    fecha: "Data",
    subproductos: "Matérias primas",
    subproducto: "Matéria prima",
    unidades: "Unidades",
    partes: "Partes",
    precio: "Preço",
    total: "Total",
    infoConsumo: "Este consumo de casas vem das despesas inseridas no intervalo de datas selecionado",
    noHay: "Não há",
    gastos: "Despesas",
    rangoDeFechas: "neste intervalo de datas.",
    configuracion: "Configuração",
    datosFiscales: "Dados fiscais",
    nombreFiscal: "Nome fiscal",
    nombreCasa: "Nome da casa",
    cifNif: "NIF",
    direccion: "Direcção",
    provincia: "Localidade",
    ciudad: "Cidade",
    codigoPostal: "Código postal",
    pais: "País",
    telefono: "telefone",
    correoElectronico: "Correio eletrônico",
    baja: "Baixo",
    guardar: "Guardar",
    cancelar: "Cancelar",
    replicar: "Replicar em outras empresas",
    replicarCasa: "Replicar a casa em outras empresas",
    seleccionarTodos: "Seleccionar tudo",
    aceptar: "Aceitar",
    casaMin: "casas",
    compras: "Compras",
    agregarCasa: "Adicionar casa",
    email: "O email",
    acciones: "Acções",
    editar: "Editar",
    enEsteNegocio: "neste negócio.",
    introduzcaNombre: "Insira o nome",
    introduzcaCifNif: "Insira o NIF",
    introduzcaDireccion: "Insira o endereço",
    introduzcaProvincia: "Insira a localidade",
    introduzcaCiudad: "Insira a cidade",
    introduzcaCodigoPostal: "Digite o código postal",
    introduzcaTelefono: "Digite o telefone",
    introduzcaCorreo: "Digite o email",
    buscar: "Procurar...",
    proveedores: "Fornecedor",
    agregarProveedor: "Agrupar fornecedor",
    proveedor: "Fornecedor",
    categoria: "Categoría",
    proveedoresMin: "Fornecedores",
    nombreProveedor: "Nome fornececedor",
    acreedor: "Credor",
    infoAcreedor: "(Se um fornecedor for um credor, ele não aparecerá no Numier POS)",
    replicarProveedor: "Replicar fornececedor em outras empresas",
    category: "Categoría",
    replicarCategory: "Rótulo replicado em outras empresas",
    etiquetas: "Etiquetas",
    etiqueta: "Etiqueta",
    sinEtiqueta: "Sem etiqueta",
    nuevaEtiqueta: "Nova etiqueta",
    agregarEtiqueta: "Adicionar etiqueta",
    tipo: "Tipo",
    etiquetaPadre: "Etiqueta Pai",
    tipoPadre: "Tipo Pai",
    nombreEtiqueta: "Nome Etiqueta",
    agregarSubproducto: "Adicionar Matéria prima",
    precioCompra: "Preço de compra",
    escandallo: "Desvio",
    subproductosCreados: "Matérias primas Criadas",
    nuevaCategoria: "Nova categoria",
    materiaPrima: "Matéria prima",
    materiasPrimas: "Matérias primas",
    nuevoProveedor: "Novo fornecedor",
    nombreSubproducto: "Nome matéria prima",
    codigoBarra: "Código de barras",
    descripcion: "Descrição",
    tipoIva: "Tipo I.V.A.",
    cuotaIVA: "Cuota IVA",
    ivaIncluido: "(IVA incluido)",
    descuentoCompra: "Desconto compra",
    porcentaje: "(% Percentagem)",
    guardarEnAlmacen: "Guardar em armazém",
    stockMinimo: "Unidades stock mínimo",
    stockOptimo: "Stock óptimo",
    gastosPorProveedoresUnidos: "Despesas de fornecedores unidos",
    referencia: "Referência",
    uds: "Uds",
    iva: "IVA",
    importe: "Importância",
    dto: "Dto",
    ttal: "Total",
    producto: "Producto",
    precioDeCoste: "Preço de custo",
    tarifa1: "Preço 1",
    tarifa2: "Preço 2",
    tarifa3: "Preço 3",
    tarifa4: "Preço 4",
    agregarProductos: "Adicionar produto",
    noHayProductosEnEsteNegocio: "Não há produtos neste negócio",
    sinCategoria: "Sem Categoría",
    nombreProducto: "Nome produto",
    codigoDeBarra: "Código de barras",
    colorBoton: "Cor do botao:",
    descuento: "Desconto",
    precioCoste: "Preço de custo",
    opcionesAlSeleccionarElArticulo: "Opções ao selecionar o produto",
    numeroDeOpcionales: "Número de matérias-primas opcionais",
    impresoraComandasTPV: "Impressora Pedidos POS",
    impresoraComandasPDA: "Impressora Pedidos PDA",
    copiaImpresoraComandasTPV: "Cópia Impressora Pedidos TPV",
    copiaImpresoraComandasPDA: "Cópia Impressora Pedidos PDA",
    impresionPlano1: "Impressora local 1",
    impresionPlano2: "Impressora local 2",
    impresionPlano3: "Impressora local 3",
    impresionKDSTPV: "Enviar pedido desde POS",
    impresionKDSPDA: "Enviar pedido desde PDA",
    pedirPrecio: "Pedir Preço",
    pedirPeso: "Pedir peso",
    pedirImporte: "Pedir valor",
    promocionable: "Promoção",
    mostrarPC: "Mostrar no PC",
    mostrarPDA: "Mostrar no PDA",
    noImprimir: "Não Imprimir",
    numeroPlato: "Número da prato defeito",
    seleccionIngredientes: "Ativar seleção de ingredientes",
    introduzcaDescripcion: "Insira a descrição",
    introduzcaCodigoDeBarras: "Insira o código de barras",
    introduzcaPrecioCoste: "Insira o preço de custo",
    opcion1: "Opção 1",
    opcion2: "Opção 2",
    opcion3: "Opção 3",
    opcion4: "Opção 4",
    opcion5: "Opção 5",
    numOpcionales: "Número de matérias-primas opcionais",
    operario: "funcionário",
    operarios: "funcionários",
    agregarOperario: "Adicionar funcionário",
    apellido: "Apelido",
    nombreOperarios: "Nome funcionário",
    pass: "Password",
    salario: "Salário",
    passTurn: "Password de turno",
    hombre: "Homem",
    mujer: "Mulher",
    replicarProducto: "Replicar produto em outras empresas",
    introduzcaEscandallo: "Introduza desvio",
    introduzcaStockMinimo: "Introduza stock mínimo",
    introduzcaStockOptimo: "Introduza stock ideal",
    introduzcaPrecioCompra: "Introduza preço compra",
    introduzcaApellido: "Introduza apelido",
    introduzcaPass: "Introduza Password",
    introduzcaEmail: "Introduza e-mail",
    introduzcaSalario: "Introduza salário",
    introduzcapassTurn: "Introduza password de turno",
    replicarOperario: "Replicar funcionário em outras empresas",
    TPV: "POS",
    precioMed: "Preço Med.",
    porUnidad: "Por unidades",
    porImporte: "Por importância",
    contrasenya: "Password PDA",
    repartidor: "Entregador",
    noMostrarEnVentas: "Não mostrar nas vendas",
    noHayOperariosEnEsteNegocio: "Não há funcionários neste negócio",
    VerDetalles: "Ver Detalhes",
    accesoDenegado: "Acesso Negado",
    
    // CLIENTES
    cliente: "Cliente",
    clientes: "Clientes",
    companyia: "Companhia",
    agregarCliente: "Adicionar cliente",
    nombreCliente: "Nome cliente",
    saldo: "Saldo",
    infoCliente: "No caso de usar cartões de crédito",
    tarifa: "Preço",
    descuentoImporte: "Valor de desconto",
    noHayClientesEnEsteNegocio: "Não há clientes neste negócio",
    impresionDeComandas: "Impressão de pedidos",
    copiaDeImpresionDeComandas: "Imprimir cópia de pedido",
    impresionPorPlana: "Impressão por local",
    monitorDeCocina: "Monitor de cozinha",
    ventas: "Vendas",
    tarjetas: "Cartões",
    cheque: "Cheque",
    cambio: "Dinheiro",
    recuento: "Contagem",
    descuadre: "Desvio",
    siguienteDia: "Dia seguinte",
    incidencias: "Incidências",
    recaudado: "Levantado",
    noHayVentasEnEsteRangoDeFechas: "Sem vendas neste intervalo de datas",
    tickets: "Tickets",
    factura: "Fatura",
    noHayFormasDePagoEnEsteRangoDeFecha: "Não existem formas de pagamento neste intervalo de datas",
    desglose: "Desglose",
    sinBase: "Sem Base",
    base: "Base",
    impuesto: "Imposto",
    facturasEmitidas: "Faturas Emitidas",
    mesa: "Mesa",
    cifnif: "NIF",
    cobro: "Recebido",
    noHayFacturasEmitidasEnEsteRangoDeFecha: "Não há faturas emitidas neste intervalo de datas",
    estadisticasAgencias: "Estatística de parcerias",
    agencia: "Parcerias",
    comentario: "Comen.",
    noHayEstadisticasDeAgenciaEnEsteRangoDeFechas: "Não há estatísticas de parcerias neste intervalo de datas",
    desglosesImpuestos: "Impostos por fechos de caixa",
    desglosesImpuestosAgencia: "Impuestos por agencia",
    noHayFormasDePagoEnEsteRangoDeFechas: "Não existem métodos de pagamento neste intervalo de datas",
    cuentasAparcadas: "Contas a crédito",
    operacion: "Operação",
    noExisteDesgloseImpuestos: "No existe desglose de impuestos.", //new
    noHayCuentasAparcadasEnEsteRangoDeFechas: "Não há contas estacionadas neste intervalo de datas",
    noHayCuentasAnuladasEnEsteRangoDeFechas: "Não há contas anuladas neste intervalo de datas",
    cierreCaja: "Fechar caixa",
    fechaCierre: "Data de fecho",
    venta: "Venda",
    totalRecaudado: "Total apurado",
    noHayCierresDeCajaEnEsteRangoDeFecha: "Não há fechos de caixa neste intervalo de datas",
    cierreCajaZ: "Caixa de fechos Z",
    n: "Nº.",
    apertura: "Abertura",
    cierre: "Fecho",
    totalVenta: "Total Vendas",
    efectivo: "Numerário",
    tarjetaCheques: "Cartão + Cheques",
    totalTeorico: "Total teórico",
    totalEnArqueo: "Total de contagem",
    cambioSig: "Cambio sig",
    volver: "Voltar",
    confirmacionImportacionHeader: "Confirmação de importação",
    confirmacionImportacionText: "Tem certeza que deseja importar?",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    registros: "registos",
    headerError: "ERRO",
    bodyError: "Insira um arquivo com menos de 10.000 registros",
    en: "Em ",
    ventasPorOperarios: "Vendas por funcionário",
    invitaciones: "Convites",
    horas: "Horas",
    sueldo: "Saldo",
    categorias: "Categorías",
    ventasPorClientes: "Vendas por cliente",
    companya: "Empresa",
    consumiciones: "Consumos",
    media: "Meia",
    mediaSesion: "Meia sessão",
    noHayAgenciasEnEsteMomento: "Não há parcerias no momento",
    agencias: "Parcerias",
    nombreAgencia: "Nome parcerias",
    comision: "Comissão",
    replicarAgencias: "Replicar parcerias",
    agregarAgencias: "Adicionar parcerias",
    nombreModificador: "Nome modificador",
    grupos: "Grupos",
    variacion: "Variação",
    resta: "Subtração",
    suma: "Soma",
    modificador: "Modificador",
    modificadores: "Modificadores",
    agregarModificador: "Adicionar modificador",
    grupo: "Grupo",
    noHayModificadoresEnEsteNegocio: "Não há modificadores neste negócio",
    almacen: "Almacén",
    todos: "Todos",
    precioCompraConIva: "Preço de compra COM IVA",
    precioCompraSinIva: "Preço de compra COM IVA",
    precioDescuentoSinIva: "Precio con descuento SIN IVA",
    codigoIdentificacion: "Código de identificação",
    replicarModificador: "Replicar modificador",
    soporteOnline: "Suporte Online",
    soporteOnlineDetails: "Suporte Online - Detalhes",
    abierto: "Aberto",
    esperandoRespuesta: "Esperando resposta",
    respondido: "Respondido",
    cerrado: "Fechadas",
    tecnico: "Técnico",
    comercial: "Comercial",
    facturacion: "Facturação",
    noTicketsEnNegocio: "Não há ingressos neste negócio",
    responderTicket: "Responder ticket",
    mensaje: "Mensagem",
    cerrar: "Fechar",
    enviarTicket: "Enviar ticket",
    nuevoTicket: "Novo ticket",
    asunto: "Assunto",
    estado: "Estado",
    departamento: "Departamento",
    visitas: "Visitas",
    verTicket: "Ver ticket",
    tarjeta: "Cartão",
    nueva: "Nova",
    replicarFormaDePago: "Replicar método de pagamento",
    nombreFormaPago: "Nome da forma de pagamento",
    formaDePago: "Formas de pagamento",
    formasDePago: "Forma de pagamento",
    agregarFormaDePago: "Adicionar método de pagamento",
    noHayFormasDePagoEnEsteNegocio: "Não existem formas de pagamento neste negócio",
    nuevo: "Novo",
    transferirProductosDeCategoria: "Produtos da categoria de transferência",
    tranferir: "Transferir",
    impresionDeProductosDeCategorias: "Impressão de produto de categoria",
    impresoraComanda: "Impressora pedidos",
    impresoraComandaTpv: "Impressora pedidos POS",
    impresoraComandaPda: "Impressora pedidos PDA",
    copiaImpresionDeComanda: "Cópia impressão pedido",
    copiaImpresoraComandasTpv: "Cópia impressão pedido POS",
    copiaImpresoraComandasPda: "Cópia impressão pedido PDA",
    impresionPorPlano: "Impressão por local",
    enviarComandaDesdeTpv: "Enviar pedidos desde POS",
    enviarComandaDesdePda: "Enviar pedidos desde PDA",
    respetarOtrasImpresiones: "Respeita outras impressões?",
    cambioDePrecioProductos: "Mudança de preço do produto",
    opcion: "Opção",
    tipoDeTarifa: "Tipo de preço",
    cambiarPrecio: "Mudar preço",
    ajustes: "Ajustes",
    cambiarImpresionDeGrupo: "Alterar impressão de grupo",
    tranferirProductosDeUnaCategoriaAOtra: "Transferir produtos de uma categoria para outra",
    cambiarPreciosAProductos: "Alterar preços para produtos",
    consumoPorHoras: "Vendas por horas",
    productosMasVendidos: "Produtos mais vendidos",
    ultimosTickets: "Últimos tickets",
    verTodos: "Ver Todos",
    arqueoDeCaja: "Contagem de caixa",
    cobrado: "Recebido",
    cajaCerrada: "Caixa fechada",
    licenciaCaducada: "Licença Expirada",
    cajonInteligente: "Gaveta inteligente",
    moneda: "Moeda",
    nivelReciclador: "Nivel Recicl.",
    totalReciclador: "Total Recicl.",
    nivelCasete: "Nivel Cofre",
    totalCasete: "Total Cofre",
    totalMonedas: "Total moedas",
    totalBilletes: "Total notas",
    totalEnDirectoPorNegocio: "Vendas en direto por negocios/s",
    enCuenta: "Em conta",
    cajaOnline: "Caixas online",
    planoDeMesas: "Mapa de mesas",
    planoDeTaquillas: "Plano de taquillas",
    nombrePlano: "Nome mapa",
    mesas: "Mesas",
    taquillas: "Taquillas",
    ocupacion: "Ocupação",
    enPlano: "No mapa",
    desgloseTicket: "Detalhe dos ticket",
    precioMedio: "Preço medio",
    apuntado: "Apontado",
    anulado: "Anulado",
    aparcado: "Estacionado",
    indicencias: "Incidentes",
    filtrarOperario: "Filtrar funcionários",
    situacionActualDeLosNivelesDelCajonInteligente: "Status atual dos níveis da gaveta inteligente",
    verDetallesDeNiveles: "Ver os detalhes do nível",
    noHayCajonInteligenteParaMostrar: "Sem gaveta inteligente para mostrar",
    consulteConSuDistribuidor: "Verifique com seu revendedor",
    comparativaVentasAnteriores: "Vendas anteriores comparativas",
    graficaDeConsumoRespectoAHistoricoDeSesiones: "Gráfico de consumo em relação ao histórico da sessão",
    graficaDeConsumoAgrupadaPorTramosHorarios: "Gráfico de consumo agrupado por tranches",
    situacionActualDeOcupacionDeMesas: "Situação atual de ocupação da mesa",
    situacionActualDeOcupacionDeTaquillas: "Situación actual de ocupación de taquillas",
    verPlanoCompleto: "Veja o mapa completo",
    rankingDeLaSesionActual: "Ranking da sessão atual",
    ultimosMovimientosDeLaCajaPorOperario: "Últimos movimentos da caixa pelo operador",
    estadoActualDeLaCaja: "Estado atual da caixa",
    turnosDeOperarios: "Turnos dos funcionários",
    relacionDeHorasTrabajadasYVentasRealizadasPorOperario: "Lista de horas trabalhadas e vendas feitas pelo funcionário",
    horarioInicio: "Hora inicio",
    horaFin: "Hora fim",
    horasTrabajadas: "Horas trabalhadas",
    noHayTurnosDeOperarioParaMostrar: "Não há turnos de operador para exibir",
    propuestaDePedido: "Proposta de pedido",
    pedidoAProveedor: "Pedido ao fornecedor",
    atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio: "Atenção, existem movimentos de armazém que não foram baixados no negócio",
    seleccionarNegocio: "Selecione o negócio",
    seleccionarProveedor: "Selecione o fornececedor",
    generarPedidoEnBlanco: "Gerar pedido em branco",
    generarPedido: "Gerar pedido",
    propuestaDePedidoA: "Proposta de pedido para ",
    buscarMateriaPrimaEnElMismoProveedor: "Encontre matéria-prima do mesmo fornecedor",
    precioIVAIncluido: "Preços com IVA incluído",
    ref: "Ref",
    nombre: "Nome",
    existencias: "Existências",
    pedido: "Pedido",
    precioArticuloUnidad: "Preço artigo / und",
    precioPedido: "Preço do pedido",
    sinIVA: "Sem IVA",
    porcentajeIVA: "% IVA",
    precioIVA: "Preço IVA",
    porcentajeDto: "% Dto",
    totalIVA: "Total IVA",
    observaciones: "Observações",
    noHaySubproductosEnEsteNegocioParaRealizarElPedido: "Não há subprodutos neste negócio para solicitar",
    recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo: "Lembre-se que para que os subprodutos apareçam eles devem estar associados a um fornecedor e configurar o stock mínimo e o stock ideal",
    guardarPedido: "Guardar pedido",
    totalIVAInc: "Total IVA Inc.",
    pedidosAProveedor: "Pedido a fornececedor",
    fechaInicio: "Data inicio",
    fechaFin: "Data fim",
    pedidosConvertidos: "Pedidos convertidos",
    nuevoPedido: "Novo pedido",
    enviarPedidos: "Enviar pedidos",
    convertido: "Convertido",
    convertirEnGasto: "Converter em custo",
    modificar: "Modificar",
    eliminar: "Eliminar",
    descargarComoPDF: "Descarregar como PDF",
    descargarComoPDFSinPrecios: "Descarregar como PDF sem preços",
    descargarComoExcel: "Descarregar como Excel",
    descargarComoExcelSinPrecios: "Descarregar como excel sem preços",
    enviarPorCorreo: "Enviar por email",
    eliminarListaCorreo: "Eliminar lista email",
    anyadirListaCorreo: "Adicionar lista de email",
    noHayPedidosAEsteProveedorEnEsteRangoDeFecha: "Não há pedidos deste fornecedor neste intervalo de datas",
    enviarPedido: "Enviar pedido",
    enviarPedidoA: "Enviar pedido a",
    formato: "Formato",
    PDF: "PDF",
    excel: "Excel",
    conPrecios: "Com preços",
    sinPrecios: "Sem preços",
    convertirPedido: "Converter pedido",
    tipoDeDocumento: "Tipo de documento",
    albaran: "Nota de entrega",
    generarEntradaEnAlmacenAlVerificar: "Gerar entrada de armazém ao verificar",
    gastosDeCasas: "Despesas de casas",
    gastosPorCasa: "Despesas por casa",
    noHayGastosPorCasasEnEsteRangoDeFechas: "Não há despesas para casas neste intervalo de datas",
    ventasDeCategorias: "Vendas de categorías",
    ventasCategoriaDe: "Vendas categoría de ",
    volverAGeneral: "Voltar ao geral",
    ventasDeProductos: "Vendas de produtos",
    filtrarPorTPV: "Filtrar por POS",
    filtrarTPV: "Filtrar POS",
    turnosDe: "Turnos de ",
    horaInicio: "Hora inicio",
    enActivo: "Ativo",
    ventasDeProductosDe: "Vendas de produtos",
    ventasOperarios: "Vendas Funcionários",
    costesDeProductos: "Custos do produto",
    totalImportesVentas: "Valores totais de vendas",
    totalCoste: "Custo total",
    costes: "Custo",
    costeUd: "Custo Ud",
    coste: "Custo",
    porcentajeCosto: "% Custo",
    varCostoMed: "Var. Custo Med.",
    listaDeInvitaciones: "Lista de convites",
    valor: "Valor",
    volverALaLista: "Voltar à lista",
    ventasDeProductosGlobal: "Vendas globais de produtos",
    porUnidades: "Por unidades",
    gastosPorEtiquetas: "Despesas por etiquetas",
    desgloseDeGastos: "Repartição de despesas",
    referencias: "Referências",
    concepto: "Conceito",
    gastosDeProveedores: "Despesas de fornecedor",
    sinProveedor: "Sem fornececedor",
    sinCasas: "Sem casas",
    cierreDeCaja: "Fecho de caixa",
    primerTicket: "Primeiro Ticket",
    ultimoTicket: "Último ticket",
    cheques: "Cheques",
    cambioSigDia: "Troca sig. día",
    ventasPorAgencias: "Vendas em parcerias",
    ventasPorFormasDePago: "Vendas por meio de pagamento",
    exportarComoHTML: "Exportar como HTML",
    pendiente: "Pendente",
    gasto: "Despesas",
    desgloseDeImpuestos: "Separação dos impostos",
    desgloseDelTicket: "Separação dos ticket",
    cuentasAnuladas: "Contas anuladas",
    buscarPorHoras: "Procurar por horas",
    mostrarVentasAcumuladasPorDia:"Mostrar vendas acumuladas por dia", 
    seleccionaUnTpv:"Deve selecionar um PDV para ver os seus detalhes",
    deshabilitarCheckboxVentasAcumuladasPorDia:"Desative a caixa de seleção ‘Mostrar vendas acumuladas por dia’ para ver os detalhes.",
    graficas: "Gráficos",
    dias: "Días",
    semanas: "Semanas",
    meses: "Meses",
    ventasPorComensales: "Vendas por n.pessoas",
    numeroDeComensales: "Número de pessoas",
    precioMedioPorComensal: "Preço médio por pessoa",
    ventasPorRangosHorarios: "Vendas por intervalos horários",
    ops: "Ops",
    comensales: "Pessoas",
    detalleDeOperaciones: "Detalhe de operações",
    operaciones: "Operaciones",
    operacionMedia: "Operação média",
    detalleDeComensales: "Detalhe por pessoas",
    comensalMedio: "Pessoa média",
    noHayVentasEnLosRangosDeFechasDefinidos: "Não há vendas nos intervalos de datas definidos",
    transferencia: "Transferência",
    domiciliacion: "Entrega Domicilio",
    fechaGasto: "Data de despesas",
    generarEntradaDeAlmacenAlVerificar: "Gerar entrada de armazém ao verificar",
    listaDeMateriaPrima: "Lista de materia prima",
    preciosIVAIncluido: "Preços IVA incluido",
    precioSinIVA: "Preço sem IVA",
    precioIVAInc: "Preço IVa inc",
    IVA: "IVA",
    totalBase: "Total base",
    totalDocumento: "Total documento",
    seleccioneUnaCasa: "Seleccione uma casa",
    anyadirNuevoSubproducto: "Adicionar novo subproduto",
    gestionDeGastos: "Gestão de despesas",
    deCaja: "De caixa",
    fueraDeCaja: "Fora de caixa",
    contabilizado: "Contabilizado",
    si: "Sim",
    no: "Não",
    grafica: "Gráfica",
    lista: "Lista",
    avanzado: "Avançado",
    noHayVentasDeProductosEnEsteRangoDeFechas: " Nenhuma venda de produto neste intervalo de datas",
    historicoDeProductos: "Histórico de produtos",
    volverA: "Voltar a",
    general: "geral",
    historialAlmacen: "Historico armazém",
    listadoDeExistencia: "Lista de existência",
    listadoDeAlmacen: "Lista de armazém",
    listadoHastaStockOptimo: "Lista até stock óptimo",
    listadoExistenciaBajoMinimo: "Lista existência abaixo mínimo",
    exportarValoracion: "Exportar valoração",
    importeDto: "Import. Dto",
    detalleDelSubproducto: "Detalhe do subproduto",
    nombreNegocio: "Nome negocio",
    noHaySubproductosConElMismoNombreEnTusOtrosNegocios: "Não há subprodutos com o mesmo nome em seus outros negócios",
    detalleAlmacen: "Detalhe do armazém",
    entrada: "Entrada",
    inventario: "Inventário",
    salida: "Saida",
    valorDto: "Valor Dto.",
    noHayDatosEnEsteMovimientoDeAlmacen: "Não há dados neste movimento de armazém",
    historial: "Historico",
    noHayMovimientoEnEstaMateriaPrima: "Não há movimento nesta matéria-prima",
    dia: "Día",
    historialDeAlmacen: "Histórico do armazém",
    inventarios: "Inventários",
    entradas: "Entradas",
    salidas: "Saidas",
    completado: "Completo",
    verificado: "Verificado",
    descargado: "Descarregado",
    diaActual: "Dia actual",
    movimientos: "Movimentos",
    enEsteRangoDeFechas: "neste intervalo de datas",
    rangosHorarios: "Intervalos de tempo",
    nuevoRangoHorario: "Novo intervalo de tempo",
    verUnInformeDeRangosHorarios: "Ver um relatório de intervalos horários",
    noHayRangosHorariosEnEsteNegocio: "Não há intervalos de tempo neste negócio",
    nombreRangosHorarios: "Nome de intervalos de tempo",
    vistaMosaico: "Vista de mosaico",
    vistaLista: "Vista em lista",
    ordenarProductos: "Ordenar produtos",
    BAJA: "Baixa",
    frontalDeVenta: "Frente de venda",
    agregarGasto: "Adicionar despesa",
    entrAlmac: "Entr. Almaz.",
    contab: "Contab",
    tranferencia: "Tranferência",
    verificar: "Verificar",
    entradaAlmacen: "Entrada de armazém",
    preciosIVAInluido: "Preços IVA Incluido",
    estaEntradaNoContieneNingunSubproducto: "Esta entrada não contém nenhum subproduto",
    cajasOnline: "Caixas online",
    minimo: "Mínimo",
    optimo: "Ideal",
    posicionGlobal: "Posição global",
    empresa: "Empresa",
    ventasSinIVA: "Vendas sem IVA",
    neto: "Líquido",
    fechaDeCumpleanyos: "Data de aniversário",
    recargoEquivalencia: "Sobretaxa de equivalência",
    anyadirMateriaPrima: "Adicionar matéria-prima",
    partesT1: "Parte T1",
    partesT2: "Parte T2",
    partesT3: "Parte T3",
    partesT4: "Parte T4",
    costeDto: "Custo Dto",
    agregarMateriasPrimas: "Adicionar Matéria-Prima",
    frontalDeVentas: "Frente de vendas",
    unidadesEnOtroNegocios: "Unidades em outros negócios",
    historialMateriaPrima: "Histórico da matéria prima",
    verDetalles: "Ver detalhes",
    borrarRangoHorario: "Apagar intervalo de tempo",
    detallesDeLaEntradaEnAlmacen: "Detalhes de entrada do armazém",
    desgloseHorasTrabajadas: "Repartição de horas trabalhadas",
    verProductosVendidos: "Ver produtos vendidos",
    verTicketsDelProducto: "Ver tickets dos produtos",
    verTicketsDeEsasInvitaciones: "Ver tickets para esses convites",
    verTicketsDeEsaAgencia: "Ver tickets de esa agencia",
    gastosPorMateriasPrimas: "Despesas de matéria-prima",
    alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta: "Quando um produto é cancelado, ele desaparece no POS para venda, mas continua a aparecer nos relatórios de vendas",
    cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta: "Quando um produto é do tipo com desconto, seu preço é deduzido do total da conta",
    alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo: "Ao ativar esta opção, os ingredientes do produto aparecem para selecioná-los",
    alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo: "Ao ativar esta opção, pode selecionar o preço do produto quando regista",
    alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo: "Ao ativar esta opção, pode selecionar o peso do produto quando regista",
    alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo: "Ao ativar esta opção, pode escolher a quantidade do produto quando regista",
    alActivarEstaOpcionElProductoNoApareceraEnNumierTPV: "Ao ativar esta opção, o produto não aparece no Numier POS",
    alActivarEstaOpcionElProductoNoApareceraEnLaPda: "Ao ativar esta opção, o produto não aparecerá no Numier PDA",
    alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada: "Ao ativar esta opção o produto não será impresso na fatura",
    guardarMateriaPrima: "Guardar matéria-prima",
    copiarMateriaPrima: "Copiar matéria-prima",
    seleccioneQueTipoDeMateriasPrimasQuiereCopiar: "Selecione o tipo de matéria-prima que deseja copiar",
    seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas: "Selecione para quais categorias você deseja copiar as matérias-primas",
    copiaMateriaPrima: "Copiar matéria prima",
    notas: "Notas",
    pedidos: "Pedidos",
    atencionLaMediaSinContarLosDiasConVentas: "Atenção: A média sem contar os dias com vendas a 0€ é de: ",
    verDesgloseDeImpuestos: "Ver detalhe de impostos",
    verDetallesDetTicket: "Ver detalhe dos ticket",
    facturasNominativas: "Faturas Nominativas",
    verDetallesDeGasto: "Ver detalhes de despesas",
    desgloseDeGastosPorEtiquetasHijas: "Discriminação de despesas por etiquetas",
    procedencia: "Origem",
    suLicenciaDeNumierOnlineEstaAPuntoDeCaducar: "A sua licença Numier Online está prestes a expirar",
    cajasOnlineTickets: "Caixas Online Tickets",
    cajasOnlineDetalles: "Caixas Online Detalhes",
    cajasOnlinePlano: "Caixas Online Mapas",
    cajasOnlineProductos: "Caixas Online Produtos",
    transferir: "Transferir",
    herramientas: "Ferramentas",
    ver: "Ver",
    detallesDeLaentradaEnAlmacen: "Detalhes de entrada do armazém",
    ups: "Ups",
    laFechaDeInicioNoPuedeSerPosteriorALaDeFin: "A data de inicio não tem",
    seleccioneUnProveedor:"Seleccione um fornececedor",
    detallesDelPedido:"Detalhes do pedido",
    correoEnviadoCorrectamente:"Email enviado correctamente",
    atencion:"Atenção",
    debeIntroducirUnEmailParaEnviarElPedido:"Deve introduzir um email para enviar o pedido",
    detalles:"Detalhes",
    gastoVerificadoCorrectamente:"Despesa correcta",
    estasSeguroDeEliminarElPedido:"Tem a certeza que pretende eliminar o pedido?",
    estaOperacionNoSePuedeDeshacer:"Esta operação não pode ser desfeita",
    siEliminarPedido:"Sim, eliminar pedido",
    pedidoEliminadoCorrectamente:"Pedido eliminado correctamente",
    laReferenciaEsObligatoria:"A referência é obrigatória",
    seleccioneLosNegociosParaHacerelPedido:"Selecione a empresa para fazer o pedido",
    noHayProveedoresEnEsteNegocio:"Não há fornecedores neste negócio",
    cuentasRectificadas:"Contas retificadas", 
    noHayCuentasRectificadasEnEsteRangoDeFechas: "Não há contas retificadas neste intervalo de datas",
    pedidosProveedor: "Pedidos de fornecedor",
    gestionDePersonal: "Gestão de pessoal",
    configuracionCarta: "Configuração da carta",
    importacionExcels:"Importação Excel",
    carta: "Carta digital",
    camaras: "Cámaras",
    perfil: "Perfil",
    cerrarSesion: "Fechar sessões",
    desarrolladoPorNexodoDigitalSL: "Desenvolvido por S4S & Nexodo Digital S.L.",
    totalValores: "Total Valores",
    totalValoresDto: "Total Valores Dto.",
    totalValoresRecuento: "Total Valores de Contagem",
    ultimoInventario: "Último inventário",
    filtrarEntreInventarios: "Filtrar entre inventários",
    ultInventario: "Ult. inventário",
    primerInventario: "Primeiro inventário",
    marcaDosInventariosParaVerLosDetallesEntreEllos: "Verifique dois inventários para ver os detalhes entre eles",
    salir: "Sair",
    anadirMovimientoAlmacen: "Adicionar Movimento de Armazém",
    nuevoInventario: "Novo Inventário",
    tienesUnInventarioSinTerminarElDia: "Tem um inventário sem terminar o dia",
    pulseElBotonRealizarInventarioPara: "Pressione o botão 'Fazer Inventário' para",
    volverARealizarlo: "Realize novamente",
    siDeseas: "Se desejar",
    comenzarElInventarioDeNuevo: "iniciar o inventário novamente",
    comaMarqueLaCasillaEliminarDatosDeInventarioActual: ", marque a caixa 'Excluir dados de inventário atual'",
    eliminarDatosDelInventarioActual: "Eliminar dados do inventário atual",
    realizarInventario: "Realizar inventário",
    accesoDenegado: "Acesso negado",
    soloPuedeComprobar2InventariosAlMismoTiempo: "Só pode verificar 2 inventários ao mesmo tempo",
    cargando: "A Carregar...",
    configuracionAlmacen: "Configuração Armazém",
    actualizada: "actualizada",
    correctamente: "corretamente",
    noSeAdmitenCamposEnBlanco: "Não pode ter campos em branco",
    todas: "Todas",
    categoriaClientes: "Categoría clientes",
    seleccionaCompania: "Selecione a empresa",
    agregarCategoriaDeClientes: "Adicionar categoria de cliente",
    categoriaPadre: "Categoría Pai",
    elCampoNombreFiscalEsObligatorio: "O campo nome fiscal é obrigatório",
    elCampoCifNifEsObligatorio: "O campo NIF é obrigatório",
    datosActualizadosCorrectamente: "Dados actualizados correctamente",
    elCampoNombreEsRequerido: "O campo nome é obrigatório",
    creada: "criado",
    rangoHorario: "Intervalo de tempo",
    soloPuedeCrearUnMaximoDeXRangosHorarios: "Só pode criar no máximo 8 intervalos de tempo",
    deAcuerdo: "De acordo",
    rangoHorario: "Intervalo de tempo",
    eliminado: "eliminado",
    deseaEliminarEsteRangoHorario: "Deseja eliminar este intervalo de tempo",
    siBorrarRangoHorario: "Sim, eliminar intervalo de tempo",
    ordenarProductosAlfabeticamente: "Ordenar produtos alfabéticamente",
    ordenarMateriasPrimasAlfabeticamente: "Ordenar materias primas alfabéticamente",
    asignarImpresorasSeleccionadasEnBlanco: "Atribuir impressoras selecionadas em branco",
    aplicarCambios: "Aplicar alterações",
    ordenarAlfabeticamenteProductos: "Ordenar alfabéticamente produtos",
    ordenar: "Ordenar",
    ordenarAlfabeticamenteSubproductos: "Ordenar alfabéticamente subprodutos",
    seleccioneElTipo: "Selecione o tipo",
    impresionDeProductosEfectuadaCorrectamente: "Impressão do produto com sucesso",
    tienesQueSeleccionarUnaCategoria: "Tem que selecionar uma categoria",
    ningunaSeleccionada: "Nenhuma selecionada",
    transferenciaDeProductosEfectuadaCorrectamente: 'Transferência de productos efectuada correctamente',
    relleneLosCamposObligatorios: "Preencha os campos obrigatórios",
    vistaFrontalTpv: "Vista frontal POS",
    editarPrecios: "Editar preços",
    cancelarEdicion: "Cancelar edição",
    guardarOrden: "Guardar ordem",
    bajaConBrackets: "[BAIXA]",
    seleccionaUnaCategoria:"Selecione uma categoría...",
    cambiarImpresorasAProductos: "Mudar impressoras nos produtos",
    igualar: "Igualar",
    sumar: "Sumar",
    restar: "Subtrair",
    multiplicar: "Multiplicar",
    todasLasTarifas: "Todas as taxas",
    productosEditadosCorrectamente: "Produtos editados corretamente",
    ordenActualizadoCorrectamente: 'Ordem actualizada correctamente',
    componentesDeVenta: "Componentes de vendas",
    delNegocioAClientes: "de negócios para clientes",
    clasificacionDe: "Classificação de",
    productosPorFamilia: "produtos por família",
    elementosQue: "Elementos que",
    varianALosProductos: "variam para produtos",
    paraLaComanda: "para o pedido",
    componentesComprados: "Componentes adquiridos",
    aProveedoresQueComponenProductos: "para fornecedores que compõem produtos",
    empresas: "Empresas",
    proveedorasDeMateriasPrimasYServicios: "fornecedores de matérias-primas e / ou serviços",
    alNegocio: "para negócios",
    fabricantesDeMateriasPrimas: "fabricantes de matérias primas",
    aProveedores: "a fornecedores",
    categoriasQueClasifican: "Categorias que classificam",
    materiasPrimasYProveedores: "matérias-primas e fornecedores",
    personalCon: "Pessoal com",
    acceso: "acesso",
    alSistema: "para o sistema",
    baseDeDatosDe: "Banco de dados de",
    consumidores: "consumidores",
    enElNegocio: "No negócio",
    clasificacionDeLa: "Classificação do",
    deLasVentas: "sobre as vendas",
    metodosDeCobro: "Métodos de Pagamento",
    enElFrontalDeVenta: "na frente de vendas",
    intervaloDeHorasParaConsultarVentas: "Intervalo de horas para consultar vendas",
    configurarAlmacén: "Configurar armazém",
    relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen: "Lista de matérias-primas para a configuração do armazém",
    herramientasGenerales: "Ferramentas gerais",
    edicionMasiva: "Edição massiva",
    categoriasCarta: "Categorias carta",
    categoriaCarta: "categoria carta",
    orden: "Ordem",
    editada: "editada",
    anadirCategoria: "Adicionar categoria",
    esteNegocioNoTieneAccesoAEsteModulo: "Esta empresa não tem acesso a este módulo",
    paraMasInformacionContacteConSu: "Para mais informações contacte o seu",
    distribuidor: "distribuidor",
    formasDePagoCarta: "Formas de pagamento carta",
    formaDePagoCarta: "forma de pagamento carta",
    informacionCarta: "Informação carta",
    datosDelNegocio: "Dados de negócios",
    nombreMostrado: "Nome exibido",
    telefonoWhatsapp: "Telefone WhatsApp",
    datosPedidos: "Dados pedidos",
    tiempoMedioDePreparacionRecogidaMin: "Tempo médio de preparação contado (min)",
    tiempoMedioDePreparacionDomicilioMin: "Tempo médio de preparação para domicilio (min)",
    gastosDeEnvio: "Custo do envío",
    pedidoMinimo: "Pedido mínimo",
    interfaz: "Interface",
    textoEntrega: "Texto entrega",
    textoPresentacion: "Texto de apresentação",
    textoFormasDePago: "Texto de métodos de pagamento",
    textoHorarios: "Texto horários",
    datosGuardadosCorrectamente: "Dados guardados corretamente",
    materiasPrimasCarta: "Matérias primas carta",
    materiaPrimaCarta: "matéria prima carta",
    referenciaMateriasPrimasTpv: "Referência materias primas POS",
    nombreDeLaMateriaPrimaEnElTpv: "Nome da matéria-prima no POS",
    disponible: "Disponivel",
    replicarMateriaPrima: "Replicar materia prima",
    replicarMateriasPrimas: "Replicar materias primas",
    nombreTpv: "Nome POS",
    noDisponible: "Não disponivel",
    replicarTodasLasMateriasPrimas: "Replicar todas as matérias primas",
    estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados: 'Tem certeza de que deseja replicar todas as matérias-primas para as empresas selecionadas?',
    estaAccionNoSePuedeDeshacer: 'Essa ação não pode ser desfeita!',
    siReplicar: 'Sím, replicar',
    productosCarta: 'Produtos carta',
    productoCarta: 'produto carta',
    referenciaProductoTpv: 'Referência produto POS',
    nombreDelProductoEnElTpv: 'Nome do produto no POS',
    seleccionaCategoria: "Selecciona categoría",
    seleccionaTipo: "Selecciona tipo",
    nIngredientesSinCosto: "Nº ingredientes sem custo",
    maximoExtras: "Máximo extras",
    alergenos: "Alérgenos",
    nombreTarifa1: "Nome Preço 1",
    precioTarifa1: "Preço 1",
    nombreTarifa2: "Nome Preço 2",
    precioTarifa2: "Preço 2",
    nombreTarifa3: "Nome Preço 3",
    precioTarifa3: "Preço 3",
    nombreTarifa4: "Nome Preço 4",
    precioTarifa4: "Preço 4",
    imagen: "Imagem",
    copiarMateriasPrimas: "Copiar materias primas",
    basico: "Básico",
    buscarNombreDeLaMateriaPrima: "Pesquise o nome da matéria-prima",
    seleccionaTipoPunto: "Selecciona tipo...",
    bases: "Bases",
    opcionales: "Opcional",
    extras: "Extras",
    cereales: "Cereais",
    crustaceos: "Crustáceos",
    huevos: "Ovos",
    pescado: "Peixe",
    cacahuetes: "Amendoim",
    soja: "Soja",
    leche: "Leite",
    frutosDeCascara: "Nozes",
    apio: "Salsão",
    mostaza: "Mostarda",
    granosDeSesamo: "Grãos de sésamo",
    dioxidoDeAzufre: "Dióxido de azufre",
    altramuces: "Tremoços",
    moluscos: "Moluscos",
    cartaASecas: "Carta",
    extra: "Extra",
    opcional: "Opcional",
    estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos: 'Este processo irá apagar as matérias-primas atuais nas categorias selecionadas dos tipos escolhidos',
    aceptarProceso: "Processo de aceitação",
    necesitasMarcarAlMenosUnTipoYUnaCategoria: "Precisa verificar pelo menos um tipo e uma categoria",
    materiaPrimaCopiadaCorrectamente: "Materia prima copiada correctamente",
    editado: "editado",
    agregada: "adicionado",
    relacion: "Relação",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: "Não pode haver duas matérias-primas com o mesmo tipo",
    estasSeguroDeBorrarLaMateriaPrima: "Tem certeza de que deseja apagar a matéria-prima?",
    siDeseoBorrarlo: "Sím, apagar",
    seleccionaUnaCarta: "Escolher uma carta",
    replicarProductos: "Replicar produtos",
    verCarta: "Ver a carta",
    verPedido: "Ver o pedido",
    verQR: "Ver QR",
    nombreEnTpv: "Nome do pos",
    cartaYPedido: "Carta e Pedido",
    replicarTodosLosProductos: "Replicar todos os produtos",
    editarImagen: "Editar imagem",
    esteNegocioNoContieneNingunaCarta: "Este negócio não contém nenhuma carta",
    estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados: 'Tem certeza de que deseja replicar todos os produtos para as empresas selecionadas?',
    sustanciasQue: "Substâncias que",
    componenALosProductos: "inventar os produtos",
    informacionAcercaDel: "Informações sobre o",
    negocioMinuscula: "negócio",
    actualizarPedidos: "Atualizar pedidos",
    pendienteDeConfirmacion: "Pendente de confirmação",
    confirmados: "Confirmado",
    enPreparacion: "Em preparação",
    finalizados: "Finalizados",
    recogida: "Recolhido",
    domicilio: "Domicilio",
    noHayPedidosPendientesDeConfirmacion: "Nenhum pedido pendente de confirmação",
    noHayPedidosConfirmados: "Nenhum pedido confirmado",
    noHayPedidosEnPreparacion: "Nenhum pedido em preparação",
    noHayPedidosTerminados: "Nenhum pedido concluído",
    siBorrarPedido: "Sim, excluir pedido",
    estasSeguroDeSuspenderElServicioEnMesas: "Tem certeza que deseja suspender o serviço da mesa?",
    siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo: "Se suspender o serviço de mesa, nenhum outro pedido de mesa entrará até que você o ative novamente",
    siSuspenderElServicioEnMesa: "Sim, suspender o serviço de mesa",
    estasSeguroDeActivarElServicioEnMesas: "Tem certeza que deseja ativar o serviço de mesa?",
    siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa: "Se ativar o serviço de mesa, os pedidos de mesa serão devolvidos",
    siActivarElServicioEnMesa: "Sim, ative o serviço de mesa",
    estasSeguroDeSuspenderElServicio: "Tem certeza que deseja suspender o serviço?",
    siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo: "Se suspender o serviço, nenhum outro pedido entrará até que você o ative novamente",
    siSuspenderElServicio: "Sim, suspenda o serviço",
    estasSeguroDeActivarElServicio: "Tem certeza que deseja ativar o serviço?",
    siActivaElServicioVolveranAEntrarPedidos: "Se você ativar o serviço, os pedidos entrarão novamente",
    siActivarElServicio: "Sim, ative o serviço",
    pedidoAceptadoCorrectamente: "Pedido aceito com sucesso",
    pedidoEnPreparacion: "Pedido em preparação",
    pedidoFinalizado: "Pedido finalizado",
    pedidoArchivado: "Pedido arquivado",
    servicioActualizadoCorrectamente: "Serviço atualizado com sucesso",
    estasSeguroDeEditarLaObservacion: "Tem certeza que deseja editar a observação?",
    siEditarObservacion: "Sim, editar observação",
    mesasActivadas: "MESAS⠀ATIVADAS⠀",
    mesasDesactivadas: "MESAS⠀DESATIVADAS⠀",
    crearNuevoProveedor: "Criar novo fornecedor",
    crearMateriaPrima: "Criar matéria-prima",
    eliminarMateriaPrima: "Eliminar Matéria Prima",
    sinCasaAsignada: "Nenhuma casa atribuída",
    buscarPorRefONombreDeLaMateriaPrima: "Pesquisa por Ref. Ou Nome da matéria-prima",
    seleccioneEtiqueta: "Selecione etiqueta...",
    unidadesStockMinimo: "Unidades stock mínimo",
    partesStockMinimo: "Partes stock mínimo",
    anadirProveedor: "Adicionar fornececedor",
    amarillo: "amarelo",
    cajas: "Caixas",
    botellas: "Garrafas",
    barriles: "Barris",
    palets: "Paletes",
    bolsas: "Bolsas",
    litros: "Litros",
    rollos: "Rolos",
    visualizar: "Visualizar",
    sinCasa: "Sem casa",
    elProveedorEsObligatorio: "Fornecedor é obrigatório",
    laFechaEsObligatoria: "A data é obrigatória",
    hayUnaMateriaPrimaSinUnidades: "Existe uma matéria-prima sem unidades",
    hayUnaMateriaPrimaSinPrecio: "Existe uma matéria-prima sem preço",
    guardandoGasto: "Despesa guardada...",
    actualizado: "actualizado",
    creado: "criado",
    laLongitudDelNombreNoPuedeSerMayorDe: "O comprimento do nome não pode ser maior que",
    relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar: "Preencha todos os dados marcados com * antes de enviar",
    seleccionaProveedor: "Selecione o fornecedor...",
    filtrarPorFecha: "Filtrar por data",
    convertirAlbaranes: "Converter notas de entrega",
    cancelarConversion: "Cancelar conversão",
    convertir: "Converter",
    convertirAlbaranEnFactura: "Converter nota de entrega em fatura",
    refFactura: "Ref fatura",
    albaranesDeLaFactura: "Notas de entrega da fatura",
    finalizada: "finalizada",
    conversion: "Conversão",
    error: "Erro",
    estaSeguroDeVerificarEsteGasto: "Tem certeza de que deseja verificar esta despesa?",
    siVerficarGasto: "Sim, verificar despesas",
    estasSeguroDeEliminarElGasto: "Tem certeza de que deseja eliminar a despesa?",
    siEliminarGasto: "Sim, elimine despesas",
    contabilizadoCambiadoCorrectamente: "Contabilizado alterado corretamente",
    gastoEliminadoCorrectamente: "Despesa eliminada corretamente",
    hacerInventario: "Fazer inventário",
    seleccionarTodas: "Selecionar Todas",
    inventarioRealizadoCorrectamente: "Inventário realizado corretamente",
    traspaso: "Transferir",
    negocioDeDestino: "Negócio de destino",
    referenciaNecesaria: "Referência necessária",
    elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos: "O movimento do armazém deve ser atribuído a um produto ou produtos",
    realizado: "realizado",
    buscarSinPuntos: "Procurar",
    enviarInventario: "Enviar inventário",
    volverAlAlmacen: "Voltar ao armazém",
    inventarioCompletado: "Inventário concluído",
    inventarioNoEncontrado: "Inventário não encontrado",
    cargandoInventario: "Carregando inventário",
    importacion: "Importação",
    importar: "Importar",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tem que selecionar um arquivo de importação",
    importandoVentasDelNegocio: "Importando vendas do negócio...",
    nuevosProductos: "Novos produtos",
    seHanCreadoLosSiguientesProductos: "Os seguintes produtos foram criados",
    importandoMovimientosDeAlmacen: "Importando movimentos de armazém...",
    importandoDatos: "Importando dados...",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tem que selecionar um arquivo de importação",
    seleccionaCasa: "Selecione uma casa...",
    desgloseDeVentasPorProductos: "Divisões de vendas por produtos",
    noTienesPermisoParaVisualizarEsteInforme: "Não tem permissão para visualizar este relatório",
    historicoVentasPorCliente: "Histórico vendas por cliente",
    buscarPorNombreDelCliente: "Procurar por nome de cliente",
    importeSinDto: "Importancia sem Dto.",
    nTickets: "Nº Tickets",
    seleccioneUnClienteValido: "Selecione um cliente válido",
    seleccioneUnNegocioParaVerLosTickets: "Selecione um negócio para ver os ticket",
    ventasDeCategoriasPorClientes: "Vendas de categórias por clientes",
    desgloseDeVentasDeLaCategoria: "Detalhe de vendas por categoria",
    verImporteEnCategoriasHijas: "Ver a quantidade em categorias filhas",
    gestionDePedidos: "Gestão de pedidos",
    cargandoGastos: "Carregar Despesas...",
    tiempoMedioCocina: "Tempo médio cozinha",
    nComandas: "Nº Pedidos",
    eliminada: "eliminada",
    tiempoMedio: "Tempo médio",
    noHayComandasEnviadasAlKdsEnEsteRangoDeFechas: "Não há pedidos enviados para o kds neste intervalo de datas",
    tiempoMedioProducto: "Tempo médio producto",
    nProductos: "Nº Productos",
    informePersonalizado: "Informação Personalizada",
    nombreDelDispositivo: "Nome do dispositivo",
    dispositivo: "Dispositivo",
    registrosHorarios: "Registros horários",
    marshallEjecutadoCorrectamente: "Marshall executado corretamente",
    mes: "Mês",
    seleccionaUnaSemana: "Seleciona uma semana",
    seleccioneUnaFechaValida: "Selecione uma data válida",
    noMayuscula: "NO",
    siMayuscula: "SIM",
    editarObservacion: "Editar observação",
    anadirObservacion: "Adicionar observação",
    editarHoraInicioYHoraFin: "Editar hora de início e hora de término",
    editarHorario: "Editar horário",
    editarHorarioDeTurno: "Editar horário de turno",
    observacion: "Observação",
    turnosOperarios: "Turnos operários",
    compartirEnlaceTurnos: "Compartilhar link de turnos",
    enlaceGeneradoExito:"Link gerado com sucesso",
    enlaceCopiadoAlPortapapeles:"Link copiado para a área de transferência",
    enlaceExternoTurnosTitle: "Link externo para consulta de turnos",
    enlaceExternoTurnosLabel: "Através deste link pode consultar os turnos dos trabalhadores. Expirará após 24 horas.",
    errorComunicacionBackend: "Erro de comunicação com o servidor.",
    enlaceExternoTurnosCaducadoTitle: "O link expirou",
    enlaceExternoTurnosCaducadoLabel: "Para verificar os turnos dos operadores, entre em contato com o administrador do negócio para gerar um novo link.",
    ventasPorOperarios: "vendas por operadores",
    ventasDeProductosMinusculas: "vendas de produtos",
    pedidosGuionPasarelaDePago: "Pedidos - Lista de Pagamento",
    numPedidos: "Num.Pedidos",
    costoPorPedido: "Custo por pedido",
    totalComisiones: "Total comissões",
    totalSinComisiones: "Total sem comissões",
    errorEnLaPeticion: "Erro de solicitação",
    rentabilidad: "Rentabilidade",
    buscarPorNombreDelRepartidor: "Pesquise pelo nome do entregador",
    verDesgloseDeTarifas: "Veja o detalhe dos valores",
    ventasPorMeses: "Vendas por meses",
    ventasHoras: "Vendas horas",
    tarifasDelProducto: "Valores por produto",
    cantidad: "Quantidade",
    fechaDesde: "Data desde",
    fechaHasta: "Data até",
    seleccionaProcedencia: "Seleciona origem...",
    verDesgloseFacturas: "Ver detalhe da fatura",
    verDesgloseMateriasPrimas: "Ver detalhe da matéria-prima",
    seleccionaUnaEtiqueta: "Selecione uma etiqueta",
    buscarPorNombreDeLaMateriaPrima: "Pesquise pelo nome da matéria-prima",
    ventasDeMateriasPrimas: "Vendas de matéria prima",
    seleccionaTpv: "Seleciona POS...",
    deVentas: "de vendas",
    totalComision: "Total comissões",
    totalSinComision: "Total sem comissões",
    desgloseFacturas: "Detalhe das faturas",
    facturasDelProveedor: "Faturas de fornecedor",
    retiradas: "Retiradas",
    buscarTicket: "Pesquisar ticket...",
    baseMayusculas: "BASE",
    numServ: "Num. Serv.",
    ticketMed: "Ticket Med.",
    necesitasElegirUnTpvParaPoderVerLosDetallesDeEste: "Precisa escolher um POS para ver os detalhes deste",
    ventasMinusculas: "vendas",
    totales: "Totais",
    noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha: "Não tem nenhum intervalo de datas criado. Quer criar um intervalo de datas?",
    siCrearUnRangoHorario: "Sim, crie um intervalo de tempo",
    detalleDe: "Detalle de ",
    cierresDeCaja: "fechos de caixa",
    ventasNegocioPorZonaHoraria: "Vendas comerciais por zona horária",
    porZonaHoraria: " por zona horária",
    detalleDeVentasSegun:"Detalhe de vendas de acordo com",
    comensalesMinuscula: " NºPessoas",
    desgloseDe: "Detalhes de ",
    ticketsCobrados: "tickets recebidos",
    segunTipoDeIVA: "de acordo com o tipo de IVA",
    facturasEmitidas: "faturas emitidas",
    aClientes: " a clientes",
    desgloseDeVentasSegun: "Detalhe de vendas por",
    formasDePagoMinusculas: "formas de pagamento",
    agenciasMinusculas: "parcerias",
    cuentasACredito: "contas a crédito",
    sumatorioDe: "Soma de",
    impuestos: "impostos",
    porFechas: " por datas",
    cuentasAnuladasMinusculas: "contas anuladas",
    delNegocio: " do negócio",
    cuentasRectificadas: "Contas retificadas",
    cuentasRectificadasMinusculas: "Contas retificadas",
    retiradasMinusculas: "retiradas",
    ventaDeProductosPorNegocio: "Vendas de produtos por empresa",
    rankingDe: "Ranking de",
    costeDeProductos: "Custo dos produtos",
    margenDeCostes: "Margem de custo",
    segunVentasPorRangoDeFecha: "com base nas vendas por intervalo de datas",
    historicoDeProducto: "Histórico do produto",
    rankingAgrupadoDe: "Ranking agrupado de",
    enTodosLosNegocios: "em todos os negócios",
    ventasDeCategoriasPorNegocio: "Vendas de categorías por negócio",
    agrupacionDe: "Agrupamento de",
    ventasDeCategoriasMinusculas: "vendas de categoria em minúsculas",
    deProductos: "de produtos",
    invitacionesMinusculas: "convites",
    ventasPorMateriasPrimas: "Vendas por matérias primas",
    ventasDeMateriasPrimasMinusculas:"vendas por matéria prima",
    comprasDeMateriasPrimas: "compras de matérias primas",
    porRangoDeFecha: "por intervalo de datas",
    comprasAProveedores: "compras a fornecedores",
    comprasAUnProveedor: "compras a um fornecedor",
    porRangoDeFechaEn: "por intervalo de datas em",
    todosLosNegocios: "todos os negócios",
    comprasAgrupadasPorEtiquetas: "compras agrupadas por etiquetas",
    comprasAFabricantes: "compras a fabricantes",
    comprasAUnFabricante: "compras a um fabricante",
    ranking: "Ranking",
    detallesDe: "Detalhes de",
    turnos: "turnos",
    ventasPorClientesPlural: "Vendas por clientes",
    deVentasPorClientes: "de vendas por clientes",
    consultaDeVentasPorCliente: "Consulta de vendas por cliente",
    historico: "Histórico",
    deVentasPorClientes: "de vendas por cliente",
    numierPedidos: "Numier Pedidos",
    informeDePasarelaDePago: "Relatório de lista de pagamento",
    desgloseDiarioDeLosPagosATraves: "Detalhamento diário de pagamentos por meio de",
    pasarelaDePagoStripe: "lista de pagamento (Stripe)",
    clicParaMasInformacion: "Clique para mais informações",
    cantidadMinusculas: "quantidade",
    totalMinusculas: "total",
    tarjetaYCheques: "Cartão e cheques",
    seleccionaOperario: "Seleciona funcionário...",
    necesitasSeleccionarUnProveedorParaPoderHacerUnPedido: "Precisa selecionar um fornecedor para poder fazer um pedido",
    estePedidoNoEsValido: "Este pedido não é válido",
    quieresRestablecerElPedido: "Quer restaurar o pedido?",
    siRestablecerPedido: "Sim, restaure o pedido",
    datosPersonales: "Dados pessoais",
    datosDeAcceso: "Dados de acesso",
    contrasenaAntigua: "Senha Antiga",
    contrasenaNueva: "Nova senha",
    confirmarContrasena: "Confirmar Senha",
    quieresDarDeAltaUnUsuario: "Você quer registrar um usuário?",
    quieresDarDeBajaUnUsuario: "Você quer cancelar o registo de um usuário?",
    licencias: "Licenças",
    fechaCaducidad: "Data de vencimento",
    ilimitado: "ILIMITADO",
    lasContrasenasNoCoinciden: "As senhas não correspondem",
    seleccionaUsuario: "Seleciona usuário...",
    usuario: "Usuário",
    negocios: "Negócios",
    balance: "Balanço",
    teHaParecidoUtilEsteArticulo: "Achou este artigo útil?",
    graciasPorTuOpinion: "Obrigado pela sua opinião",
    asignarTurno: "Atribuir turno",
    vacaciones: "Férias ",
    descargarPDF: "Descarregar PDF",
    enviarHorario: "Enviar Horário",
    incidenciasEnElMes: "incidentes no mês",
    diasDeVacacionesEnElMes: "dias de férias no mês",
    diasDeVacacionesEnElAno: "dias de férias no ano",
    nuevoTurno: "Novo turno",
    clonarTurno: "Copiar turno",
    nombreDelTurno: "Nome do turno",
    diasDeLaSemana: "Días da semana",
    editarTurno: "Editar turno",
    borrarTurno: "Apagar turno",
    evento: "Evento",
    nombreEvento: "Nome evento",
    hayUnaIncidenciaEnEsteTurno: "Há um problema nesta mudança de turno",
    fechaInicioTurno: "Data inicio turno",
    fechaFinTurno: "Data fim turno",
    numHorasTurno: "Nº horas turno",
    fechaInicioTrabajada: "Data de início trabalhada",
    fechaFinTrabajada: "Data final trabalhada",
    numHorasTrabajadas: "Nº horas trabajadas",
    noIniciado: "Não iniciado",
    noFinalizado: "Não finalizado",
    fechaInicioVacaciones: "Data de início do férias",
    fechaFinVacaciones: "Data final das férias",
    turnoHorario: "Turno horário",
    nombreTurno: "Nome turno",
    campoRequerido: "Campo requerido",
    introduzcaLosDiasDeLaSemana: "Insira os dias da semana",
    crearTurnoHorarioDeOperario: "Criar turno horário do funcionário",
    introduzcaLosOperarios: "Insira os funcionários",
    laboral: "Laboral",
    vacacional: "Período de férias",
    seleccionaTurno: "Seleciona turno...",
    seleccionaLosNegociosALosQueQuiereClonarElTurno: "Selecione as empresas que deseja copiar a alteração",
    seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios: "Selecione a data em que deseja copiar os horários",
    seleccioneUnaSemana:"Selecione uma semana",
    lunes: "Segunda-feira",
    martes: "Terça-feira",
    miercoles: "Quarta-feira",
    jueves: "Quinta-feira",
    viernes: "Sexta-feira",
    sabado: "Sábado",
    domingo: "Domingo",
    laFechaSeleccionadaNoEsValida: "A data selecionada não é válida",
    turnoClonadoCorrectamente: "Turno copiado correctamente",
    correoEnviadoCorrectamente: "Email enviado correctamente",
    estasSeguroDeBorrarElTurnoSeleccionado: "Tem certeza que deseja apagar o turno selecionado",
    siBorrarTurno: "Sím, apagar turno",
    necesitasCrearAlgunTurnoParaPoderCrearCuadrantes: "Precisa criar um turno para poder criar quadrantes",
    estasSeguroDeEditarElTurno: "Tem certeza que deseja editar o turno?",
    siEditarTurno: "Sim, editar turno",
    hoy: "Hoje",
    turno: "Turno",
    turnoBorradoCorrectamente: "Turno apagado correctamente",
    informacion: "Informação",
    elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido: "O dia não corresponde à configuração do turno escolhido",
    turnoCopiadoCorrectamente: "Turno copiado correctamente",
    turnoDeOperarioAgregadoCorrectamente: "Turno de funcionário agregado correctamente",
    turnoDeOperarioEliminadoCorrectamente: "Turno de funcionário eliminado correctamente",
    turnoDeOperarioEditadoCorrectamente: "Turno de funcionário editado correctamente",
    tecnicoConsultasTecnicasIncidencias: "Técnico (Consultas técnicas, Incidencias...)",
    comercialActivacionDeProductosInformacionServicios: "Comercial (Activação de produtos, Informações, Serviços...)",
    administracionFacturacionReclamaciones: "Administração (Facturação, Reclamações...)",
    elAsuntoEsObligatorio: "O assunto é obrigatório",
    elMensajeEsObligatorio: "A mensagem é obrigatório",
    soporteOnlineEnviadoCorrectamente: "Suporte Online enviado com sucesso",
    todosLosNegociosMayusculas: "Todas as empresas",
    recordarMisDatos: "Lembrar os meus dados",
    paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros: "Para qualquer assunto ou mais informações pode contactar connosco",
    iniciarSesion: "Iniciar sassão",
    haOlvidadoSuContrasena: "Esqueceu-se da sua senha?",
    haHabidoUnErrorAlConectarPruebeDeNuevo: "Ocorreu um erro ao conectar. Tente novamente",
    elEmailNoPuedeEstarEnBlanco: "Email não pode ficar em branco",
    elEmailNoEsValido: "O email não é válido",
    laContrasenaNoPuedeEstarEnBlanco: "A senha não pode ficar em branco",
    estaPaginaNoSeEncuentraEnElSistema: "Esta página não pode ser encontrada no sistema",
    volverAlInicio: "Voltar ao inicio",
    obtenerContrasena: "Obter a senha",
    disculpeLasMolestiasEstamosDeMantenimiento: "Desculpe o transtorno, estamos em manutenção",
    vuelvaAIntentarloMasTarde: "Por favor, tente novamente mais tarde",
    acepto: "Aceito",
    categoriasDeClientes: "Categórías de clientes",
    categoriaDeCliente: "categóría de cliente",
    nombreCategoria: "Nome categóría",
    noSeleccionada: "Não selecionada",
    cobradoMayusculas: "RECEBIDO",
    envioProgramadoPara: "Envío programado para",
    eliminarPedido: "Eliminar pedido",
    aceptarPedido: "Aceitar pedido",
    pedidoConfirmado: "Pedido confirmado",
    archivarPedido: "Arquivar pedido",
    detallesPedido: "Detalhes pedido",
    nota: "Nota",
    precioUd: "Preço Ud",
    gratis: "GRÁTIS",
    guardarYAceptarPedido: "Guardar e aceitar pedido",
    seleccionaGrupo: "Seleciona grupo...",
    todosMayusculas: "TODOS",
    nombreOperario: "Nome funcionário",
    apellidos: "Apelidos",
    claveAcceso: "Chave acesso",
    codigoDeTurnos: "Código de turnos",
    claveAccesoPDA: "Chave acesso PDA",
    seleccionaIVA: "Seleciona IVA",
    calcularCostoAPartirDeMateriasPrimas: "Calcule o custo das matérias-primas",
    seleccionaImpresoraDeComandasTPV: "Seleciona impressora de pedidos do POS",
    seleccionaImpresoraDeComandasPDA: "Seleciona impressora de pedidos do PDA",
    buscarMateriaPrima: "Pesquisa de matéria prima",
    nuevaMateriaPrima: "Nova matéria prima ",
    ordenarSubproductos: "Ordenar subproductos",
    seleccionaEtiqueta: "Seleciona etiqueta...",
    clonarProducto: "Copiar produto",
    clonarProductoCarta: "Copiar produto",
    buscarSinPuntos: "Procurar",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: 'Não pode haver duas matérias-primas com o mesmo tipo',
    sinProveedores: "Sem fornecedores",
    agregadas: "adicionadas",
    modificadas: "modificadas",
    materiaPrimaEliminadaCorrectamente: "Matéria prima eliminada correctamente",
    asociacion: "associação",
    materiaPrimaOrdenadaCorrectamente: "Matéria-prima ordenada corretamente",
    productosCopiadosCorrectamente: "Produtos copiados corretamente",
    responder: "Responder",
    cliente: "Cliente",
    administracion: "Administração",
    soporteTecnico: "Suporte técnico",
    horaInicioMayusculas: "Hora Inicio",
    horaFinal: "Hora Final",
    personaDeContacto: "Pessoa de contacto",
    motivoVisita: "Motivo visita",
    servicioBajoMantenimiento: "Serviço de baixa manutenção",
    desplazamiento: "Deslocamento",
    ticketEnviadoCorrectamente: "Ticket enviado corretamente",
    precioCompraConDescuento: "Preço de compra com desconto",
    introduzcaLasPartesDelStockMinimo: "Insira as partes do stock mínimo",
    actualizarStockMinimoYOptimo: "Atualizar stock mínimo e ideal",
    subproductoDeVerdad: "Subproducto",
    entregado: "Entregue",
    retirada: "Retirada",
    subtotal: "Subtotal",
    pagosACuenta: "Pagamentos por conta",
    horaDeApertura: "Hora de abertura",

    condicionesDeNumierOnline: "Condições Numier Online",
    descripcionDelServicio: "Descrição do Serviço",
    terminosIntroduccionParte1: "O serviço de nuvem S4S - Numier oferecido pela S4S - NEXODO DIGITAL S.L. (a partir de agora S4S - NEXODO), oferece aos seus clientes acesso online a informações atualizadas sobre os seus negócios.",
    terminosIntroduccionParte2: "Para isso, os aplicativos de ponto de venda do S4S - Numier enviarão pela internet os detalhes das vendas realizadas e outras informações que possam interessar aos seus clientes.",
    terminosIntroduccionParte3: "O acesso a este serviço será feito através do site https://www.numier.com/online, onde poderá consultar as informações enviadas pelos seus pontos de venda.",
    terminosIntroduccionParte4: "A S4S - NEXODO reserva-se o direito de melhorar, modificar ou cancelar o serviço a qualquer momento.",
    politicaDePrivacidad: "Política de privacidade",
    privacidadParte1: "1. A S4S - NEXODO faz a seguinte declaração de privacidade para expressar a sua firme intenção de proteger sua privacidade. A S4S - NEXODO pede que leia esta política de privacidade cuidadosamente antes de usar este serviço, pois isso implica que a S4S - NEXODO coleta e processa seus dados pessoais de acordo com esta política. A S4S - NEXODO reserva-se o direito de modificar a política de privacidade a qualquer momento. Nesse caso, a S4S - NEXODO compromete-se a contactá-lo para informá-lo das alterações que o afetem. ",
    privacidadParte2: "2. S4S - NEXODO respeite suas escolhas de privacidade. No caso de nos fornecer qualquer informação, ela será tratada de acordo com esta política.",
    privacidadParte3: "3. S4S - NEXODO recomenda discrição ao fornecer informações aos proprietários ou operadores de sites. É importante ter em mente que fornecer informações pessoais em locais de acesso público, como salas de chats, significa que qualquer pessoa com acesso à Internet pode ter suas informações. Recomendamos que não insira nenhuma informação que não deseja que outras pessoas vejam nessas áreas públicas.",
    privacidadParte4: "4. Se decidir registrar-se no NUMIER ONLINE, pode ter que fornecer dados pessoais. É importante registar corretamente as informações sobre a data de registro. Se suas informações pessoais forem alteradas após o registro, você deve alterá-las ou atualizá-las imediatamente. Caso contrário, pode não receber nenhum serviço ou informação da S4S - NEXODO.",
    privacidadParte5: "5. S4S NEXODO pode usar suas informações pessoais com a finalidade de fazer melhorias neste site.",
    privacidadParte6: "6. S4S NEXODO recolhe esses dados a fim de obter informações para aprimorar seus serviços e produtos. E podemos usar as informações que forneceu para enviar ofertas por e-mail ou correio que possam ser do seu interesse.",
    privacidadParte7: "7. Para cancelar a assinatura desses e-mails, deve entrar em contato com a S4S - NEXODO para informar a sua decisão. Caso contrário, a S4S - NEXODO mantem as informações do usuário até o momento do cancelamento da assinatura ou até o vencimento de qualquer período necessário descrito no regulamento em vigor. ",
    privacidadParte8: "8. A S4S - NEXODO não divulgará seus dados a terceiros sem o seu consentimento, a menos que possamos provar de boa fé que é necessário ou exigido. ",
    privacidadParte9: "9. Tem a possibilidade de cancelar todos os dados da sua assinatura que aparecem na nossa base de dados. Para tal, deverá contactar a S4S - NEXODO e fazer o seu pedido. ",
    privacidadParte10: "10. S4S NEXODO tomou medidas para garantir que as informações só estarão disponíveis para o usuário que originalmente inseriu as informações. ",
    privacidadParte11: "11. As informações só podem ser acessadas depois que a senha for inserida.",
    privacidadParte12: "12. Este site pode conter links para outros sites que não estão associados à S4S - NEXODO. Esses sites têm suas próprias políticas de privacidade, pelas quais a S4S - NEXODO não é responsável. O acesso a esses sites vinculados é de sua exclusiva responsabilidade.",
    privacidadParte13: "13. A S4S - NEXODO garante a segurança das informações de seus usuários, exceto nos casos descritos a seguir:",
    privacidadParte13dos: "- Se a S4S - NEXODO tiver o seu consentimento.",
    privacidadParte13tres: "- Se a S4S - NEXODO for advertida a fornecer tais informações por indicação legal, exigência judicial ou outro procedimento legal.",
    privacidadParte13cuatro: "- Caso a divulgação destes dados seja necessária para proteger os direitos e propriedade da S4S - NEXODO.",
    privacidadParte13cinco: "- Se a divulgação de seus dados for necessária para melhorar os serviços e produtos de nossos clientes, incluindo o próprio.",
    privacidadParte14: "14. A S4S - NEXODO garante a manutenção adequada de suas informações num servidor seguro e incriptado que só pode ser acessado por terceiros autorizados. ",

    //NUEVO
    cartaDigital: "Carta digital",
    horarios: "Horarios",
    zonas: "Zonas",
    modificarHorariosDeLaCarta: "Modificar horarios de la carta",
    modificarZonasDeLaCarta: "Modificar zonas de la carta",
    diaDeLaSemana: "Día de la semana",
    esteNegocioNoTieneCarta: "Este negocio no tiene carta",
    tipoDeEnvio: "Tipo de envío",
    nuevoHorario: "Nuevo horario",
    elCampoDiaDeLaSemanaEsRequerido: "El campo día de la semana es requerido",
    borrarHorario: "Borrar horario",
    laHoraInicioNoPuedeSerMayorQueLaHoraFin: "La hora inicio no puede ser mayor que la hora fin",
    noHayHorariosEnEsteNegocio: "No hay horarios en este negocio",
    deseaEliminarEsteHorario: "¿Desea eliminar este horario?",
    siBorrarHorario: "Sí, borrar horario",
    seleccioneDiaDeLaSemana: "Seleccione día de la semana",
    seleccioneTipoDeEnvio: "Selecciones tipo de envío",
    importacionSage: "Importación Sage",
    ejercicio: "Ejercicio",
    codigoEmpresa: "Codigo Empresa",
    asiento: "Asiento",
    cargoAbono: "Cargo Abono",
    codigoCuenta: "Codigo Cuenta",
    fechaAsiento: "Fecha Asiento",
    comentario: "Comentario",
    importeAsiento: "Importe Asiento",
    numeroPeriodo: "Número Periodo",
    delegacion: "Delegación",
    canal: "Canal",
    ejercicioFactura: "Ejercicio Factura",
    serie: "Serie",
    factura: "Factura",
    suFacturaNo: "Su Factura No",
    fechaFactura: "Fecha Factura",
    importeFactura: "Importe Factura",
    tipoFactura: "Tipo Factura",
    codigoCuentaFactura: "Código Cuenta Factura",
    codigoRetencion: "Código Retención",
    baseRetencion: "Base Retención",
    porRetencion: "Por Retención",
    importeRetención: "Importe Retención",
    baselva1: "Baselva 1",
    porlva1: "Porlva 1",
    cuotaIva1: "Cuota IVA 1",
    porRecargoEquivalencia1: "Por Recargo Equivalencia 1",
    recargoEquivalencia1: "Recargo Equivalencia 1",
    codigoTransaccion1: "Código Transacción 1",
    descargarComoTxt: "Descargar como .txt",
    noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha: "No hay asientos contables en este tpv con este rango de fecha",
    cargandoAsientosContables: "Cargando asientos contables",
    fechaDeAperturaDeCaja: "Fecha de apertura de caja",
    fechaDeCierreDeCaja: "Fecha de cierre de caja",
    descargarVentas: "Descargar ventas",
    descargarGastos: "Descargar gastos",
    noHasCerradoEstaCaja: "No has cerrado esta caja",
    numeroDeCierres: "Número de cierres",
    introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE: "Introduzca el ultimo número de asiento contable que tiene en SAGE",
    porFavorRelleneElAsientoContable: "Por favor, rellene el asiento contable",
    descargar: "Descargar",
    elAsientoContableDebeSerUnNumero: "El asiento contable debe ser un número",
    elAsientoContableNoPuedeSerMayorA10Digitos: "El asiento contable no puede ser mayor a 10 dígitos",
    TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos: "Tenga en cuenta que utilizaremos los siguientes números a este para completar los datos",
    noExistenVentasEsteDia: "No existen ventas este día",
    noExistenGastosEsteDia: "No existen gastos este día",
    enSage: "en SAGE",
    proyecto: "Proyecto",
    codigoEmpresaHelp: "Recuerda que el dato empresa se comparte entre todos los negocios de la misma empresa",
    cuentasDelTpvSeleccionado: "Cuentas del TPV seleccionado",
    nuevaCuenta: "Nueva cuenta",
    nombreDeCuenta: "Nombre de cuenta",
    codigoCuentaMinuscula: "Código cuenta",
    tipoDeCuenta: "Tipo de cuenta",
    noHayCuentasCreadasConElTpvSeleccionado: "No hay cuentas creadas con el TPV seleccionado",
    crearNuevaCuenta: "Crear nueva cuenta",
    codigoDeLaCuenta: "Código de la cuenta",
    codigoDeLaSubcuenta: "Código de la sub cuenta",
    configuracionCuentasIva: "Configuración cuentas IVA",
    configuracionCuentasEspeciales: "Configuración cuentas especiales",
    cuenta: "Cuenta",
    subcuenta: "Sub cuenta",
    editarCuenta: "Editar cuenta",
    tipo: "Tipo",
    sage200: "SAGE 200",
    exportarContabilidad:"Contabilidade de exportação",
    noHayAsientosContablesEnEsteNegocio: "No hay asientos contables en este rango de fecha",
    cargandoAsientosContables: "Cargando asientos contables",

    enSage: "en Sage",
    proyecto: "Proyecto",
    codigoEmpresaHelp: "Recuerda que el dato empresa se comparte entre todos los negocios de la misma empresa",
    cuentasDelTpvSeleccionado: "Cuentas del TPV seleccionado",
    nuevaCuenta: "Nueva cuenta",
    nombreDeCuenta: "Nombre de cuenta",
    codigoCuentaMinuscula: "Código cuenta",
    tipoDeCuenta: "Tipo de cuenta",
    noHayCuentasCreadasConElTpvSeleccionado: "No hay cuentas creadas con el TPV seleccionado",
    crearNuevaCuenta: "Crear nueva cuenta",
    codigoDeLaCuenta: "Código de la cuenta",
    codigoDeLaSubcuenta: "Código de la sub cuenta",
    configuracionCuentasIva: "Configuración cuentas IVA",
    configuracionCuentasEspeciales: "Configuración cuentas especiales",
    cuenta: "Cuenta",
    subcuenta: "Sub cuenta",
    editarCuenta: "Editar cuenta",
    tipo: "Tipo",
    sage200: "Sage 200",
    losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos: "Los campos nombre, código de cuenta y código de subcuenta deben estar rellenos",
    estaSeguroDeQueDeseaEliminarEstaCuenta: "¿Está seguro de que desea eliminar esta cuenta?",
    siBorrarCuenta: "Sí, borrar cuenta",
    cuentaEditadaCorrectamente: "Cuenta editada correctamente",
    cuentaCreadaCorrectamente: "Cuenta creada correctamente",
    configuracionSAGE: "Configuración SAGE",
    sinCuentaAsociada: "Sin cuenta asociada",
    loSientoSuNegocioNoTieneContratadoSAGE: "Lo sentimos, su negocio no tiene contratado SAGE",
    paraMasInformacionContacteConComerciales: "Para más información contacte con comerciales",
    laLongitudMaximaDeLasSubCuentas: "La longitud máxima de la sub cuenta tiene que ser de 12 caracteres",
    codigo: "Código",
    crearNuevoCodigoCuenta: "Crear nuevo código cuenta",
    editarNuevoCodigoCuenta: "Editar nuevo código cuenta",
    seleccioneUnaFormaDePagoParaElGasto: "Seleccione una forma de pago para el gasto",
    hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna: "Has seleccionado albaranes con diferentes formas de pago, por favor seleccione una",
    seleccioneUnaFormaDePago: "Seleccione una forma de pago",
    zonasActualizadasCorrectamente: "Zonas actualizadas correctamente",
    zonaCreadaCorrectamente: "Zona creada correctamente",
    zonaEditadaCorrectamente: "Zona editada correctamente",
    guardarCambios: "Guardar cambios",
    laZonaNoPuedeTenerElNombreEnBlanco: "La zona no puede tener el nombre en blanco",
    zonasDeReparto: "Zonas de reparto",
    editarZona: "Editar zona",
    color: "Color",
    costeDeReparto: "Coste de reparto",
    pedidoMinimo: "Pedido mínimo",
    crearNuevaZona: "Crear nueva zona",
    estasSeguroDeQueQuieresEliminarLaZona: "¿Estás seguro de que quieres eliminar la zona?",
    estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos: "Esta zona dejará de estar disponible inmediatamente y no se harán pedidos desde la misma",
    siEliminarZona: "Sí, eliminar zona",
    zonaEliminadaCorrectamente: "Zona eliminada correctamente",
    ventasExportadas: "Ventas exportadas",
    gastosExportados: "Gastos exportados",
    todosLosCierresDeEsteDiaHanSidoExportados: "Todos los cierres de este día han sido exportados",
    faltanVentasPorExportarEsteDia: "Faltan ventas por exportar este día",
    todosLosGastosDeEsteDiaHanSidoExportados: "Todos los gastos de este día han sido exportados",
    faltanGastosPorExportarEsteDia: "Faltan gastos por exportar este día",
    /*this.$i18n.t("productos"))*/

    /*"$i18n.t('editar')*/

    //10-02-2021
    otros:'Otros',
    restriccionHorarios:'Restricción Horarios',
    restriccionHorariosDesc: "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
    borrar: 'Borrar',
    restriccion: "Restricción", 
    nMaximoPedidos: "Nº Máximo de pedidos",
    cerrarFranja: "Cerrar franja",
    limitePedidos: "Límite Nº Pedidos",
    loSentimosSuNegocioNoTieneContratadoEsteModulo: "Lo sentimos, su negocio no tiene contratado este módulo",
    numeroPedidosPermitidos: "Número de pedidos permitidos",
    estaSeguroDeQueDeseaEliminarEstaRestriccion: "¿Está seguro de que desea eliminar esta restricción?",
    siBorrarRestriccion: "Sí, borrar restricción",
    loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion: "Lo sentimos, para acceder a este módulo necesita activar la configuración",
    costeSinIVA: "Coste sin IVA",

    //11.3.2021
    importeIVA: "Importe IVA",

    //17.3.2021
    pasarAPreparacion: "Pasar a preparación",
    pasarAPreparados: "Pasar a preparados",
    pasarAEnReparto: "Pasar a en reparto",
    finalizarPedido: "Finalizar pedido",
    //Tener en cuidado con los espacios, ya que son los espacios Braille
    domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
    domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
    recogerActivado: "RECOGER⠀ACTIVADO",
    recogerDesactivado: "RECOGER⠀DESACTIVADO",
    //
    conDetalles: "con detalles",
    zonasRepartoActivadas: 'ACTIVADAS⠀',
    zonasRepartoDesactivadas: 'DESACTIVADAS⠀',
    siEliminarCategoria: "Sí, eliminar categoría",
    confirmaEliminarCategoria: "¿Está seguro de que quiere eliminar esta categoría?",
    pedidoPreparado: "Pedido preparado",
    configuracionParaLaImportacionExportacionDeDatosDeSage: "Configuración para la importación/exportación de datos de Sage",
    enEstaPantallaSeConfiguranLosCodigosDeLasCuentas: "En esta pantalla se configuran los códigos de las cuentas",
    formadosPor3Digitos: 'formados por 3 dígitos',
    estosSonNecesariosParaConfigurarLasCuentasContables: "Estos son necesarios para configurar las cuentas contables",
    alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente: "Al editar un código relacionado con una cuenta contable ya existente",
    todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta: "todo cambio que se produzca sobre este afectará también a la propia cuenta",
    aContinuacionSeListaranLasCuentasDeTipo: "A continuación se listarán las cuentas de tipo",
    gastoMinuscula: "gasto",
    paraQue: "para que",
    asocieMinuscula: "asocie",
    ventaMinuscula: "venta",
    unaParaSuPosterior: "una para su posterior",
    relacionEnSage: "relación en SAGE",
    seleccioneUnaCuenta: "Seleccione una cuenta",
    aDomicilio: "A domicilio",
    aRecoger: "A recoger",
    tipoDeZona: "Tipo de zona",
    seleccioneUnTipo: "Seleccione un tipo",
    kilometrosDelArea: "Kms del área",
    codigoEmpleado: "Codigo empleado",
    exportarReservas: "Exportar reservas",
    importacionSinqro: "Importación Sinqro",
    configuracionParaLaImportacionDeDatosDeSinqro: "Configuración para la importación de datos de Sinqro",
    pasarelaDePago: "Pasarela de pago",
    importeSinDescuento: "Importe sin descuento",
    desactivarZona: "Desactivar zona",
    activa: "ACTIVA",
    inactiva: "INACTIVA",
    exportarPdfConMateriasPrimasAsociadas: "Exportar PDF con materias primas asociadas",
    exportarExcelConMateriasPrimasAsociadas: "Exportar Excel con materias primas asociadas",

    //Pedidos archivados 18/05/21
    informePedidosDetalle:"Desglose de pedidos",
    informePedidos:"Informe de pedidos",
    tipoPago:"Forma de pago",
    tipoPedido:"Tipo de pedido",
    domicilio:"Envio a domicilio",
    recoger:"Recogida en local",
    pagoLocal:"Pago en local",
    otro:"Otro",

    //25/05/2021
    configuracionTurnos: "Configuración turnos",

    //2021/05/20
    estasSeguroDeImportarTusProductosASinqro: "¿Desea importar sus productos a Sinqro?",
    esteProcesoPuedeTardarVariosMinutos: "Este proceso puede tardar varios minutos.",
    siImportarConSinqro: "Sí, importar a Sinqro",
    estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
    podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
    siDarDeBaja: "Sí, dar de baja",
    estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
    podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
    siDarDeAlta: "Sí, dar de alta",
    laImportacionTardara: "Importando... este proceso puede tardar varios minutos",
    importacionFinalizada: "Importación completada con exito",
    completo: "Completado",
    vale: "Vale",
    importarSinqro: "Importar Sinqro",
    importandoProductos: "La importación se está llevando a cabo en estos momentos...",
    generandoCarta: "Este es el último paso... Estamos generando su carta.",
    procesoFin: "El proceso se ha completado con éxito",
    procesoCompletado: "Proceso completado",
    yaFaltaPoco: "Ya falta poco...",
    estamosEnEllo: "Estamos trabajando en la importacion. Por favor, no recargue el navegador. " ,
    finProgres: "El progreso terminó con exito.",
    textoInfo:"Esta columna muestra el precio de compra con descuento (el cual se calcula a partir del precio sin IVA)",
    correosEnviados: "E-mails enviados",
    correosEnviadosCorrectamente: "Os e-mails foram enviados com sucesso.",
    errorAlEnviar: "Erro ao enviar",
    noSePudieronEnviarTodosLosCorreos: "Nem todos os e-mails puderam ser enviados:",
    errorInesperadoEnvioCorreos: "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde",


    //07/06/2021
    valorRecuento: "Valor Recuento",
    
    //08/06/2021
    obligatorioEmail: "Obligatorio rellenar email",
    datosCliente : "Datos cliente",

    //11/06/2021
    recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:"Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
    yQue: "y que",
    losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:"los descuentos de las ventas estan al 0% de IVA",

    //16/06/2021
    totalValoresNegativos: "Total Valores Negativos",
    solamenteSeTieneEnCuentaValoresPositivos: "Solamente se tiene en cuenta valores positivos",
    totalValoresDiferencia: "Total Valores Diferencia",
    totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
    valorDiferencia: "Valor diferencia",
    valorDifereciaDto: "Valor diferencia dto.",
    precioDto: "Precio Dto.",

    //24/06/2021
    exportarMateriasPrimasAsociadasAEsteProducto: "Exportar materias primas asociadas a este producto",
    sinIVA: "Sin IVA",

    //MENÚS
    menus: "Menús",
    descripcionMenus: "Grupo de productos que se venden de forma conjunta",
    numeroDePlatos: "Número de platos que el cliente podrá elegir por cada plato:",
    platosTip1: "En esta pantalla se pueden crear los distintos platos que",
    platosTip2: "componen el menú para su posterior asignación con los productos.",
    productosPlatosTip: "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
    plato: "Plato",
    platos: "Platos",
    primerPlato: "Primer plato",
    segundoPlato: "Segundo plato",
    tercerPlato: "Tercer plato",
    cuartoPlato: "Cuarto plato",
    quintoPlato: "Quinto plato",
    sextoPlato: "Sexto plato",
    seleccionaUnPlato: "Selecciona un plato",
    noPuedeDejarEnBlancoElNombreDeUnPlato: "No puede dejar en blanco el nombre de un plato",
    estaSeguroDeQueQuiereBorrarEstePlato: "¿Está seguro de que quiere borrar este plato?",
    seBorraranTodasLasAsociacionesDeProductosConElMismo: "Se borrarán todas las asociaciones de productos con el mismo",
    siEstoySeguro: "Sí, estoy seguro",
    estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado: "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
    dejaraDeFormarParteDelMenuDeFormaInstantanea: "Dejará de formar parte del menú de forma instantánea",
    noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
    clonarMenu: "Clone",
    //29/07/2021
    totalPedidosDevueltos : "Nº de devoluciones",
    totalImportesDevueltos : "Total importe devuelto",

    //06/08/2021
    NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
    //10/08/2021
    noMostrarDescuento: "No mostrar descuentos",
    //17/08/2021
    operarioApertura: "Operario apertura",
    aperturasPorOperarios: "Cuentas abiertas por operario",
    aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
    aperturasOperarios : "Cuentas abiertas",
    productosPorAperturaDe: "Productos por apertura de",
    productosPorApertura:"Productos por apertura",
    facturasEmitidasMinuscula:"facturas emitidas",
    noMostrarDescuento: "No mostrar descuentos",

    //17/08/2021
    rangosDeMesas: "Rangos de mesas",
    agrupacionesDeMesasParaConsultarVentas: "Agrupaciones de mesas para consultar ventas",
    verUnInformeDeRangosDeMesas: "Ver un informe de rangos de mesas",
    nuevoRangoMesa: "Nuevo rango mesa",
    mesaInicial: "Mesa inicial",
    mesaFinal: "Mesa final",
    noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
    nombreRangoDeMesas: "Nombre rango de mesas",
    borrarRangoMesas: "Borrar rango de mesas",
    deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
    siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
    ventasPorRangoDeMesas: "Ventas por rango de mesas",
    porRangoDeMesas: " por rango de mesas",
    numeroDeOperaciones: "Número de operaciones",
    precioMedioPorOperacion: "Precio medio por operación",
    propuestoParaCierre: "Propuesto para cierre",
    esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo: "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
    siCerrarTicket: "Sí, cerrar ticket",
    propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
    noEstoyDeAcuerdo: "No estoy de acuerdo",
    ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
    escribaAquiSuRespuesta: "Escriba aquí su respuesta",
    enviarRespuesta: "Enviar Respuesta",
    tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

    //26/08/2021
    exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
    soloPuedesSacarInformesDeUnMesComoMaximo: "Solo puedes sacar informes de un mes como máximo",
    loSentimos: "Lo sentimos",
    noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas: "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
    siCrearUnRangoMesas: "Sí, crear un rango mesas",
    // 07/08/2021
    usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

    //08/09/21
    pedidosHoras: "Pedidos por horas",
    graficaPedidosHoras: "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

    //20/09/21
    personalizacionCarta: "Personalizacion de la Carta Online",
    personalizacionCarta: "Personaliza tu carta ",
    personalizacion: "Personalización",
    conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
    opcionesConfiguracion: "Opciones de configuración",
    vistaPrevia: "Vista previa",
    imagenCargando: "Imagen de carga",

    //21/09/21
    diagnosis: "Diagnosis",
    diagnosticoProductos : "Diagnóstico de productos",
    comprobacionProducts: "Comprobación de productos", 
    diagnosticarProductos: "Diagnosticar productos",
    productosSinRelacionEnElTpv : "¡Todo correcto!",
    pulseElBoton:"Pulse el botón deseado",
    paraRealizarDiagnosis : "para realizar la diagnosis",
    productoRelacionadoConTpv : "Relacionado en el TPV con",
    noTieneRelacion:"No tiene relacion",
    hayProductosSinRelacion:"Hay productos que no estan relacionados en el TPV",
    
    //20/09/21
    destacadosTitulo: "Titulo destacado",
    nuevoTitulo: "Nuevo titulo",
    tituloActual: "Titulo actual",

    //22/09/21
    textos: "Textos",

    //21/09/21
    facturas: "Facturas",
    facturasMinusculas: "facturas",
    facturacionGeneral: "Facturación general",
    deTodasLasSeries: " de todas las series",

    //29/09/21
    permisoBusinessGestion: "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
    permisoUsuarioGestion: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    traduccion: "Traducción",
    traduccionDe: "Traducción de",
    idioma: "Idioma",
    losDescuentosDeLasVentasEstanAlCeroDeIva: "Los descuentos de las ventas están al 0% de iva",
    recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo: "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
    mapasYZonas: "Mapas y zonas",
    idiomas: "Idiomas",
    permisoControlIdiomas: "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
    idiomasCartaTip1: "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
    idiomasCartaTip2: "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
    idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
    excluirPrecioMedioMenu: "Excluir del precio medio los productos de los menús",

    //19/06/2023
    conIvaDesglosado: "com IVA discriminado",

    //10/01/24
    tolTipLogo: "Adicione o logotipo do seu restaurante para aparecer na tela inicial e no seu código QR. O tamanho recomendado é de 90 x 90 px.",
    tolTipFondo: "Adicione uma foto de alta qualidade para aparecer como capa no seu menu QR. O tamanho recomendado é de 1280 x 1024 px.",
    tolTipImagenProducto: "Adicione uma imagem de alta qualidade para mostrar visualmente e atrair atenção para o seu produto. Para produtos no menu, crie um novo com uma resolução ideal de 500 x 500 pixels ou 12 cm x 12 cm.",
    tolTipNombreMostrado: "Digite aqui o nome que você deseja que seja exibido para o seu negócio.",
    tolTipEmail: "Forneça um e-mail de contato para seus clientes.",
    tolTipTelefono: "Forneça um número de telefone de contato.",
    tolTipDescripcion: "Descreva brevemente o seu restaurante: o conceito e a experiência que você oferece.",
    tolTipDireccion: "Forneça o endereço do restaurante a que pertence este menu.",
    tolTipPresentacion: "Escreva uma chamada para ação adequada para que seus clientes queiram abrir seu cartão na tela inicial.",
    tolTipHorario: "Apresente o seu horário ou compartilhe informações extras (feriados, fora de serviço...).",
    tolTipMostrarCategoriaDeBaja: "Se marcar a caixa, as categorias que você desativou serão exibidas, mas não aparecerão no seu menu.",
    tolTipMostrarProductoDeBaja: "Se marcar a caixa, os produtos que você desativou serão exibidos, mas não aparecerão no seu menu.",
    tolTipTraducirCategoria: "Traduza para o idioma desejado o título das categorias.",
    tolTipConvertirCategoriaPadre: "Tornar-se uma categoria principal",
    tolTipOrdenCategorias: "Se deseja que esta categoria apareça como a primeira, o número deve ser '1', e assim por diante, de acordo com a ordem.",
    tolTipBajaCategoria: "Ao ativar esta opção, a categoria selecionada deixará de aparecer no seu menu digital quando os clientes acessarem. A desativação de uma categoria implica que todos os produtos incluídos sob essa categoria específica também deixarão de ser visíveis para seus clientes.",
    tolTipVerQr: "Acesse e faça o download do código QR do seu menu.",
    tolTipDisponibleProducto: "Marque a disponibilidade do produto: Indique se um produto está disponível ou não no seu menu.",
    tolTipIdiomaProducto: "Escolha o idioma em que deseja que o produto seja apresentado.",
    tolTipOrdenProducto: "Escolha a ordem em que deseja que o produto apareça dentro da categoria selecionada.",
    tolTipProductoDestacado: "Se selecionar esta opção, o produto aparecerá em uma seção destacada no início do menu. Destaque produtos especiais ou promoções.",
    tolTipBaja: "Se selecionar esta opção, o produto aparecerá em uma seção destacada no início do menu. Destaque produtos especiais ou promoções.",
    tolTipDisponible:  "Ative o botão se o produto estiver disponível para venda. Desative se o produto estiver 'Fora de Estoque' (sem estoque).",
    tolTipImagenCarga:  "Imagem que será exibida durante os breves segundos em que o seu menu está sendo carregado.",
    tolTipTituloDestacado:  "Aqui você pode definir o texto que nomeará a seção de produtos em destaque. Ex: 'Sugestões do Chef', 'Nossos Mais Vendidos' ou 'Imperdíveis'.",
    tolTipIdiomaMateriaPrima: "Escolha o idioma em que também pretende que a matéria-prima seja apresentada",
    guiaUsuario : "Guia do Usuárior",
    
    //12/03/24
    basesFree: "Bases extras gratuitas",
    extrasFree: "Bases / Extras gratuitos",
    tooltipBaseExtra: "Se a base estiver ativada, não adiciona extra gratuitamente. Se o extra estiver ativado, não será contado como gratuito ao ser adicionado.",

    exportar: "Exportação",
    codigoBarras: "Código de barras",

    //WALLET
    passbooks: "Passbooks",
    sharePassbooks: "Compartilhar wallets",
    copyToClipboard: "Copiar para a área de transferência",
    shareViaEmail: "Enviar por e-mail",
    shareViaWhatsapp: "Enviar pelo WhatsApp",
    copied: 'Copiado para a área de transferência',
    selectBusinessForWallet: 'Escolha o negócio para o qual deseja enviar as Wallets',
    sendMethod: 'Método de envio',
    share: "Enviar",
    sendAndSaveButton: 'Sim, enviar e salvar',
    sendAndNoSaveButton: 'Não, enviar e não salvar',
    titleSaveInfoModalText: 'As informações do cliente foram alteradas. Deseja salvar essas informações?',
    verifyNumberText: 'Verifique o número de telefone',
    verifyEmailText: 'Verifique o e-mail',
    selectOption: 'Selecione uma opção',
    clipboardCopied: 'Copiado para a área de transferência',
    clipboardFailedToCopy: 'A API da área de transferência não está disponível neste navegador.',
    enviarWallet: 'Enviar Wallet',
    confirmacionEnvioWallet: 'Confirmação de Envio da Wallet',
    confirmacionTextoEnviarWallet: 'Tem certeza de que deseja enviar a wallet para todos os clientes?',
    mensajeConfirmacion: "Esta ação não pode ser desfeita e será enviada apenas para os clientes cujo e-mail esteja adicionado e possuam um Código de barras.",
    enviar: "Enviar",
    noHayCorreosElectronicos: "Não há e-mails.",
    ningunClienteConCorreoElectronico: "Nenhum cliente com e-mail configurado foi encontrado.",
    clientHasNoBarcode: "O cliente não tem um código de barras definido.",

    exportarCarta: "Exportar cardápio",
    exportarSimplifiedExcel: "Exportar como Excel (Sem cabeçalhos)",

    //18/10/24
    listadoTicketRepartidor: "Tickets por entregador",
    //GESTIÓN DE IMPUESTOS
    taxes: "Impostos",
    tax: "Imposto",
    gestionImpuestos: "Gestão de Impostos",
    administracionTiposTasas: "Administração",
    administracionTiposTasasImpositivas: " de tipos e taxas de impostos",
    agregarImpuesto: "Adicionar Imposto",
    taxRate: "Imposto Aplicado",
    taxDescription: "Descrição",
    taxType: "Tipo de Imposto",
    taxBoldType: "impostos",
    impuestoAplicadoEsCero: "O Imposto Aplicado não pode ser menor que ",
    impuestoYaCreado: "Este imposto já existe e não pode ser criado novamente",

    //IMPORTAR CLIENTES 
    previewClientData: "Pré-visualização",
    editarCliente: "Editar cliente",
    importarData: "Importar dados",
    importandoDatos: "Importando dados",
    peview: "Pré-visualizar",
    importacionRealizada: "Importação realizada",
    datosImportados: "Os dados foram importados com sucesso",
    confirmarImportacion: "Confirmar importação",
    seguroContinuarImportacion: "Tem certeza de que deseja continuar? Esta ação é irreversível",

    //18/11/24
    //Update-Logo
    inserteImagen: "Inserir Imagem",
    seleccioneArchivoImagen: "Selecione um arquivo de imagem",
    archivoDemasiadoGrande: "O arquivo é grande demais. O tamanho máximo permitido é 5MB.",
    dimensionesExcedenLimite: "As dimensões da imagem excedem o limite permitido (2000x2000px).",
    mensajeconfirmacion: "Você está prestes a substituir a imagem existente. Deseja salvar?",
    botonGuardar: "Salvar",
    botonCancelar: "Cancelar",
    Guardado: "Guardado",
    guardarOvisualizarLogo: "Visualizar ou guardar logo",
    seleccionLogo: "Clique para selecionar um Logo",
    volver: "Voltar",
    noHayImagen: "Não há imagem salva.",
    informacion: "Informação:  ",
    tamaño: "Tamanho: ",
    dimensiones: "Dimensões: ",
    restriccionesLogo: "Restrições do logo:",
    tamañoMaximo: "Tamanho máximo: ",
    dimensionesMaximas: "Dimensões máximas: ",

    //13/12/24
    //ProductosNoRelacionados.NEW
    mensajeAviso: "Tem certeza de que deseja gerar automaticamente os PLUs? Este processo gerará um código para cada produto e tarifa não configurados, e será salvo automaticamente.",
    mensajeAvisoSubProducto: "Tem certeza de que deseja gerar automaticamente os PLUs? Este processo gerará um código para cada matéria-prima não configurada e será salvo automaticamente.",
    aviso: "Aviso!",
    generarPlu: "Gerar Automaticamente PLUs",
    botonAceptar: "Aceitar",
    PLUsGenerados: "PLUs gerados corretamente!",
    errorGenerandoPLUs: "Erro ao gerar os PLUs",

    //21/01/2025
    nosmudamos: "Estamos mudando!",
    noscambiamosaselfi: "O seu negócio deu um grande passo: agora fazemos parte da família Selfibar. A partir de agora, todas as configurações e gestões poderão ser feitas diretamente no Selfibar",
    irASelfibar: "Ir para o Selfibar",

    barcodeUnico: "Código de barras único",
    barcodeNecesarioSeActualizara: "O código de barras é necessário para esta ação e será atualizado para este cliente ao enviar ou copiar para a área de transferência.",

    //ListadomateriaPrima-Proveedor.
    //14/01/25
    verListado: "Lista de matérias-primas",
    listadoMateriaPrimaProveedor: "Lista de Matéria Prima Fornecedor",
    noTiene: "Não tem ",
    esteProveedor: " este fornecedor",
    proveedor: "Nome do Fornecedor:   ",
    precioAcordado: "Preço acordado com o fornecedor",
    porcentajeAcordado: "Percentagem acordada",
    FiltrarPorEtiqueta: "Filtrar por etiqueta:",
    precioAcordadoGuardadoCorrectamente: "Preço acordado salvo com sucesso!",
    fijarprecio: "Definir preço ",
    preciofijado: "(Definir o preço da matéria-prima)",
    mensajePrecioFijado: "O preço da matéria-prima é de  ",
    explicacionFijarPrecio: "Ao ativá-lo, o preço da matéria-prima e o percentual de desconto serão fixados. Ao fazer uma nova despesa, nem o preço nem o desconto serão modificados.",
    porcentajeAcordado: "Percentual de aviso",
    porcentajeAcoradoGuardado: "Percentual acordado. Salvo com sucesso!",
    SubproductoIncrementado: "Matéria-prima aumentada",
    LosSubproductosSeHanIncrementado : "Não foi possível verificar a despesa, pois foi detectado um aumento no preço das seguintes matérias-primas em relação ao percentual acordado com o fornecedor",
    errorverificar: "Erro ao verificar",
    MateriaPrimasIncremento:"Foi registrado um aumento de 5% nas seguintes matérias-primas: ",
    ConfirmacionGuardar: "Deseja salvar?",
    Elsubproducto: " A matéria-prima ",
    MensajeErrorVerificarTodo: "Não é possível verificar todas as despesas, pois as seguintes despesas apresentam aumento no preço da matéria-prima em relação ao percentual acordado com o fornecedor",
    explicacionPorcentajeAcordado: "Este é o percentual acordado com o fornecedor para o controle do preço das matérias-primas ao realizar uma despesa.",
    generarBusinessHash: "Gerar URL para operários",
    enlaceFicharTurnosOperario: "Acesso para registrar e consultar turnos",
    enlaceFicharTurnosOperarioDescripcion: "Os trabalhadores do negócio podem iniciar sessão com as mesmas credenciais do POS para registrar o início e o fim do seu turno, bem como consultar os últimos 14 turnos realizados e seus tempos.",

};


// WEBPACK FOOTER //
// ./src/language/portuguese.js